export default {
  common: {
    edit: 'Edit',
    yes: 'Yes',
    no: 'No',
    or: 'or',
    search: 'Search',
    none: 'None',
    save: 'Save',
    error: 'Error',
    reset: 'Reset',
    input: 'Input',
    cancel: 'Cancel',
    next: 'Next',
    back: 'Back',
    selectHeaders: 'Select visible headers',
    weekday: 'Weekday',
    from: 'From',
    delete: 'Delete',
    to: 'To',
    deliveryAt: 'Delivery At',
    ok: 'Ok',
    add: 'Add',
    disable: 'Disable',
    enable: 'Enable',
    remove: 'Remove',
    empty: 'There is nothing to see here.',
    selectToImport: 'Please select a file to import',
    selectVenue: 'Please select a venue.',
    import: 'Import',
    export: 'Export',
    legacyExport: 'Legacy Export',
    file: 'File',
    apply: 'Apply',
    applySelectedFilters: 'Apply selected filters',
    filters: 'Filter',
    orders: 'Orders',
    overview: 'Overview',
    others: 'Others',
    skip: 'Skip',
    time: 'Time',
    date: 'Date',
    register: 'Register',
    submit: 'Submit',
    confirmDelete: 'Are you sure you want to delete this item? This action cannot be undone.',
    form: {
      file: 'File',
    },
    all: 'All',
    single: 'Single',
    teedeli: 'Teedeli',
    selectItems: 'Please select at least one item.',
    noSelection: 'No Selection',
    description: 'Description',
    invoice: 'Invoice',
    name: 'Name',
    tag: 'Tag',
    tags: 'Tags',
    test: 'Test',
    shoppingCart: 'Shopping Cart',
    send: 'Send',
    recommendation: 'Recommendation',
    generate: 'Generate',
    selectAll: 'Select all',
    singleImageAllowed: 'Only one image is allowed!',
    imageFilesOnly: 'Only image files are allowed!',
    fileSizeExceed: 'File size exceeds the maximum of {max}MB!',
    imageMaxSizeNotice: 'The image should be at most {max}MB in size!',
    copyId: 'Copy ID',
    copiedToClipboard: 'Copied to clipboard!',
    imagesDragAndDrop: 'Drag & Drop',
    browseFiles: 'Browse Files',
    videoPreview: 'Video Preview',
    fileName: 'File Name',
    fileSize: 'File Size',
    videoDuration: 'Video Duration',
    videoResolution: 'Video Resolution',
    uploadProgress: 'Upload Progress',
    uploadVideo: 'Upload Video',
    videoFileOnly: 'Video files only!',
    dragAndDropVideoHere: 'Drag and drop your video here',
    uploadComplete: 'Upload complete',
  },
  feedback: {
    title: 'Send feedback',
    fields: {
      name: 'Name',
      email: 'Email',
      comments: 'What happened?',
    },
    actions: {
      open: 'Open feedback dialog',
      submit: 'Send feedback',
    },
    notification: {
      sent: 'Feedback sent.',
    },
  },
  languageField: {
    add: 'Add other',
    picker: 'Language',
  },
  countries: {
    de: 'Germany',
    au: 'Austria',
    fr: 'France',
    li: 'Liechtenstein',
    lu: 'Luxembourg',
    ch: 'Switzerland',
    es: 'Spain',
    is: 'Iceland',
    ic: 'Canary Islands',
    pt: 'Portugal',
    cz: 'Czech Republic',
    nl: 'Netherlands',
    be: 'Belgium',
    no: 'Norway',
    dk: 'Denmark',
    se: 'Sweden',
    ae: 'UAE',
    lt: 'Lithuania',
    fi: 'Finland',
    gb: 'United Kingdom',
    it: 'Italy',
    om: 'Oman',
  },
  toolbar: {
    selectOrSearchVenue: 'Select or search venue...',
    noSelection: 'No Venue Selected',
    copyShortId: 'Copy short id',
  },
  masterTypes: {
    web: 'Web',
    terminal: 'Terminal',
  },
  login: {
    caption: 'Smoothr is the shortcut for the digitization of your restaurant.',
  },
  dashboard: {
    index: 'Dashboard',
    totalSum: 'Total Revenue',
    totalVenues: 'Showing results of {total} venues.',
    totalNetSum: 'Total Net Revenue',
    orderSum: 'Number of Orders',
    provisionSum: 'Provision',
    form: {
      customerGroup: 'Select Customer Group',
    },
    table: {
      total: 'Total',
      totalNet: 'Total Net',
      numberOfOrders: 'Number Of Orders',
      venue: 'Venue',
      readableId: 'Short ID',
      provision: 'Provision',
    },
  },
  provision: {
    index: 'Provision',
    overview: 'Overview',
    claim: 'Claim Provision',
    select: 'Select or search venue to show payments',
    claimHelp: 'Select a venue and a period to claim the provision.',
    success: 'Success',
    sum: 'Sum',
    waiting: 'Waiting',
    notClaimed: 'Not claimed',
    notification: {
      claiming: 'Provision will be claimed. After a few minutes, please refresh the site to see the changes.',
    },
    form: {
      venue: 'Venue',
    },
    table: {
      sum: 'TotalPrice',
      method: 'Method',
      status: 'Status',
      createdAt: 'Created At',
      provision: 'Provision Status',
      provisionClaimedAt: 'Claimed At',
    },
  },
  inventory: {
    index: 'Inventory',
    overview: 'Overview',
    stock: 'Stock',
    product: 'Products',
    add: 'Create',
    form: {
      stock: 'Stock',
      product: 'Select products',
    },
    table: {
      stock: 'Stock',
      inventoryItems: 'Products',
      createdAt: 'Created At',
    },
  },
  company: {
    index: 'Company',
    overview: 'Overview',
    general: 'Details',
    deliveryAddress: 'Delivery Address',
    invoiceAddress: 'Invoice Address',
    add: 'Create',
    create: 'Create',
    edit: 'Edit',
    form: {
      venue: 'Venue',
      name: 'Name',
      companyCode: 'Company Code',
      email: 'E-Mail',
      phoneNumber: 'Phone Number',
      vatNumber: 'VAT',
      orderMinimum: 'Order Minimum',
      subsidy: 'Subsidy',
      subsidyOrderMinimum: 'Subsidy Order Minimum',
      paymentMethod: 'Payment Method',
      iban: 'Iban',
      storeDiscount: 'Store Discout (%)',
      isPaidByCompany: 'Paid by Company',
      city: 'City',
      area: 'Nearest City',
      street: 'Street',
      streetAddress: 'Street Address',
      number: 'Number',
      company: 'Company',
      postalCode: 'Postal Code',
      gpsManualInput: 'Manual Input (GPS Coordinates)',
      gpsCorrect: 'GPS Coordinates ok?',
      latitude: 'Latitude',
      longitude: 'Longitude',
      deliveryTime: 'Delivery Time',
      useDeliveryAddressAsInvoice: 'Use Delivery Address for Invoice Address',
    },
    table: {
      venue: 'Venue',
      name: 'Name',
      createdAt: 'Created At',
      companyCode: 'Company Code',
      email: 'E-Mail',
      phoneNumber: 'Phone Number',
      vatNumber: 'VAT',
    },
    tabs: {
      general: 'General',
      openingHours: 'Opening Hours',
      deliveryTime: 'Delivery Time',
    },
    notification: {
      emptyOpeningHours: 'The opening hours are empty. Please set the opening hours.',
    },
  },
  uiBanner: {
    index: 'Banner',
    overview: 'Overview',
    general: 'Details',
    add: 'Create',
    create: 'Create',
    edit: 'Edit',
    empty:
      // tslint:disable-next-line:max-line-length
      "It looks like you haven't added any UI Banners yet. Create your first UI Banner now!",
  },
  uiCard: {
    index: 'Card',
    overview: 'Overview',
    general: 'Details',
    add: 'Create',
    create: 'Create',
    edit: 'Edit',
    empty:
      // tslint:disable-next-line:max-line-length
      "It looks like you haven't added any UI Cards yet. Create your first UI Card now!",
  },
  uiSlider: {
    index: 'Slider',
    overview: 'Overview',
    general: 'Details',
    add: 'Create',
    create: 'Create',
    edit: 'Edit',
    empty:
      // tslint:disable-next-line:max-line-length
      "It looks like you haven't added any UI Sliders yet. Create your first UI Slider now!",
  },
  notification: {
    form: 'Please fill out the form.',
    400: "The request wasn't valid.",
    401: "Your credentials aren't valid.",
    422: 'There was an unexpected validation error. Please check the form.',
    404: "The requested resource couldn't be found.",
    403: 'You are not allowed to view this page.',
    500: 'There was an internal server error.',
    mfa: 'The MFA-Code is invalid.',
    unknown: 'There was an unknown error.',
    downloadInProgress:
      'Your download will be prepared. You can still navigate on the site. The download of your file will start automatically, when it is ready.',
    downloadFailed: 'One of your downloads failed. Please try again later.',
    downloadSuccess: 'Your download is ready!',
    gpsError:
      'GPS position for provided address was not found. Please change the address or enter gps coordinates manually.',
    successfulDownload: 'The export has been sent to your email address',
    retryCheckoutIntegrationAction: 'Retry successfully',
    needOpeningHours: 'Please set opening hours first!',
    needDeliveryHours: 'Please set delivery hours first!',
    visibleOptionGroupError: 'This option group is required. At least 1 option article needs to be visible',
  },
  gender: {
    index: 'Gender',
    male: 'Male',
    female: 'Female',
    other: 'Other',
  },
  displayModes: {
    default: 'Default',
    launcher: 'Launcher',
    smartPicker: 'Smart Picker',
    detailOverlay: 'Detail Overlay',
    detailDialog: 'Detail Dialog',
    grid: 'Grid',
    pagedGrid: 'Paged Grid',
    circle: 'Circle',
    topSeller: 'Top Seller',
    matrix: 'Matrix',
    banner: 'Banner',
    drinkFlavor: 'Drink Flavor',
    toggleButton: 'Toggle Button',
    flavor: 'Flavor',
    checkbox: 'Checkbox',
    radio: 'Radio',
    code: 'Code',
  },
  displayIdentifiers: {
    extra: 'Extra',
    extra15: 'Extra 15',
    extra30: 'Extra 30',
    extraCheese15: 'Extra Cheese 15',
    extraCheese30: 'Extra Cheese 30',
    size: 'Size',
    size15: 'Size 15',
    size30: 'Size 30',
    cheese: 'Cheese',
    kids: 'Kids',
    salad: 'Salad',
    bread: 'Bread',
    cookie1: '1x Cookie',
    cookie3: '3x Cookie',
    cookie12: '12x Cookie',
    chips: 'Chips',
    sauce: 'Sauce',
    drink: 'Drink',
    water: 'Water',
    tea: 'Tea',
    hotBeverages: 'Hot Beverages',
    menu: 'Menu',
    main: 'Main',
    sub: 'Sub',
    wrap: 'Wrap',
    sides: 'Sides',
    fullPrice: 'Full Price',
    inverse: 'Inverse',
    code: 'Code',
  },
  venueSelector: {
    title: 'Select Venue',
    search: 'Please select a venue',
    back: 'Back to venues',
  },
  currency: {
    eur: 'Euro',
    chf: 'Swiss Frank',
    isk: 'Icelandic kronur',
    czk: 'Czech kronur',
    aed: 'UAE Dirham',
    sek: 'Swedish Krona',
    dkk: 'Danish Kroner',
    nok: 'Norwegian Kroner',
    gbp: 'British Pound',
    omr: 'Omani Rial',
  },
  routes: {
    smoothrPay: {
      index: 'Smoothr Pay',
      detail: 'Merchant',
      payments: 'Payments',
      payouts: 'Payouts',
    },
    venue: {
      index: 'Venue',
      create: 'Create Venue',
      createSimple: 'Create Venue',
      copyFoodcard: 'Copy foodcard',
      edit: 'Edit Venue',
      panic: 'Panic Settings',
      editSimple: 'Edit Venue',
      verify: 'Verify Venue',
      publish: 'Publish Venue',
      migrate: 'Migrate Venue',
      sync: 'Sync Venue',
      copy: 'Copy Venue',
    },
    screensaver: {
      index: 'Screensaver',
      create: 'Create screensaver',
      edit: 'Edit screensaver',
    },
    employeeNotification: {
      index: 'Employee Notification',
      create: 'Create Employee Notification',
    },
    banner: {
      index: 'Banners',
      create: 'Create banner',
      edit: 'Edit banner',
    },
    venueLabel: {
      index: 'Venue Label',
      create: 'Create Venue Label',
      edit: 'Edit Venue Label',
    },
    sepa: {
      index: 'SEPA settings',
    },
    productCombos: {
      index: 'Product combos',
    },
    promo: {
      index: 'Promo Codes',
      create: 'Create Promo Code',
      createTeedeli: 'Create Teedeli Promo Code',
      edit: 'Edit Promo Code',
      export: 'Export Promo Code',
      exportTeedeli: 'Export Teedeli Promo Code',
      disable: 'Disable Promo Codes',
      createMultiple: 'Create Multiple Promo Codes',
    },
    cupCode: {
      index: 'Cup Codes',
      create: 'Create Cup Code',
      edit: 'Edit Cup Code',
    },
    coupon: {
      index: 'Coupon (deprecated)',
      create: 'Create Coupon',
      edit: 'Edit Coupon',
      export: 'Export Coupon',
      disable: 'Disable Coupon',
      createMultiple: 'Create Multiple Coupon',
    },
    maintenance: {
      index: 'Maintenance',
    },
    provision: {
      index: 'Provision',
    },
    inventory: {
      index: 'Manage Inventory',
      create: 'Create Inventory',
      edit: 'Edit Inventory',
    },
    payment: {
      index: 'Payment',
    },
    home: {
      index: 'Home',
    },
    reporting: {
      index: 'Reporting',
    },
    register: {
      index: 'Franchisee Information',
      venue: 'Register Venues',
      success: 'Registration Success',
    },
    analytics: {
      index: 'Analytics',
    },
    sales: {
      index: 'Sales',
    },
    salesOverview: {
      index: 'Sales Overview',
    },
    receipt: {
      index: 'Receipts',
    },
    eposJobs: {
      index: 'Epos Jobs',
    },
    sanifairLogs: {
      index: 'Sanifair Logs',
    },
    automatedReports: {
      index: 'Automated Reports',
      create: 'Create Automated Report',
    },
    billing: {
      index: 'Billing',
    },
    userExport: {
      index: 'User export',
    },
    activityLogExport: {
      index: 'Activity logs',
    },
    lightspeed: {
      index: 'Lightspeed',
      success: 'Authorization successful',
      error: 'Authorization failed',
    },
    statistics: {
      index: 'Statistics',
    },
    error: {
      index: 'Error',
      notFound: '404 Page Not Found',
      forbidden: '401 Forbidden',
    },
    user: {
      index: 'User',
      create: 'Create User',
      edit: 'Edit User',
      createSimple: 'Create User',
      editSimple: 'Edit User',
    },
    role: {
      index: 'Role',
      create: 'Create Role',
      edit: 'Edit Role',
    },
    customerGroupProprty: {
      index: 'Customer Group Proprty',
      create: 'Create Customer Group Proprty',
      edit: 'Edit Customer Group Proprty',
    },
    foodcard: {
      index: 'Import Foodcard',
    },
    printer: {
      index: 'Printer',
      edit: 'Edit Printer',
    },
    tag: {
      index: 'Tag',
      create: 'Create Tag',
      edit: 'Edit Tag',
    },
    information: {
      index: 'Information',
      create: 'Create Information',
      edit: 'Edit Information',
    },
    constrain: {
      index: 'Tradegroup',
      create: 'Create Tradegroup',
      edit: 'Edit Tradegroup',
    },
    printGroups: {
      index: 'Printgroups',
      create: 'Create Printgroups',
      edit: 'Edit Printgroups',
    },
    dashboard: {
      index: 'Dashboard',
    },
    auditing: {
      index: 'Auditing',
    },
    enrollments: {
      index: 'Enrollments',
    },
    table: {
      index: 'Table',
      create: 'Create Table',
      edit: 'Edit Table',
    },
    category: {
      index: 'Category',
      create: 'Create Category',
      edit: 'Edit Category',
    },
    subscriptionCategories: {
      index: 'Subscription Category',
      create: 'Create Subscription Category',
      edit: 'Edit Subscription Category',
    },
    subscription: {
      index: 'Subscription',
      create: 'Create Subscription',
      edit: 'Edit Subscription',
    },
    membership: {
      index: 'Membership',
      create: 'Create Membership',
      edit: 'Edit Membership',
    },
    article: {
      index: 'Article',
      create: 'Create Article',
      edit: 'Edit Article',
      editSimple: 'Edit Article',
    },
    articleManager: {
      index: 'Article Manager',
    },
    recommendation: {
      index: 'Cart Recommendation',
      create: 'Create Cart Recommendation',
      edit: 'Edit Cart Recommendation',
    },
    option: {
      index: 'Option',
      create: 'Create Option',
      edit: 'Edit Option',
      editSimple: 'Edit Option',
    },
    customer: {
      index: 'Customer',
      create: 'Create Customer',
      edit: 'Edit Customer',
      import: 'Import Customer',
    },
    translation: {
      index: 'Translation',
    },
    loyaltyPrograms: {
      index: 'Loyalty Programs',
      create: 'Create Loyalty Program',
      edit: 'Edit Loyalty Programs',
    },
    comoManagedGifts: {
      index: 'Como Managed Gifts',
    },
    sync: {
      index: 'Sync',
      create: 'Create Sync',
      upsell: 'Create Upsells Sync',
    },
    aggregatorSyncs: {
      index: 'Syncs',
    },
    posSync: {
      index: 'POS Sync',
    },
    injectionRates: {
      index: 'Injection Rates',
    },
    company: {
      index: 'Companies',
      create: 'Create Company',
      edit: 'Edit Company',
    },
    ui: {
      banner: {
        index: 'Banners',
        create: 'Create Banner',
        edit: 'Edit Banner',
      },
      card: {
        index: 'Cards',
        create: 'Create Card',
        edit: 'Edit Card',
      },
      slider: {
        index: 'Sliders',
        create: 'Create Slider',
        edit: 'Edit Slider',
      },
    },
    campaign: {
      index: 'Campaigns',
      create: 'Create Campaign',
      edit: 'Edit Campaign',
    },
    releases: {
      index: 'Releases',
      create: 'Create Release',
      edit: 'Edit Release',
    },
    upsells: {
      index: 'Upsells',
    },
    depositRule: {
      index: 'Deposit Rules',
      create: 'Create Deposit Rule',
      edit: 'Edit Deposit Rule',
    },
    healthCheck: {
      index: 'Healthcheck',
      create: 'Create Healthcheck',
      edit: 'Edit Healthcheck',
    },
    forgotPassword: 'Forgot Password',
    resetPassword: 'Reset Password',
  },
  weekdays: {
    monday: 'Monday',
    mondayShort: 'Mon',
    tuesday: 'Tuesday',
    tuesdayShort: 'Tue',
    wednesday: 'Wednesday',
    wednesdayShort: 'Wed',
    thursday: 'Thursday',
    thursdayShort: 'Thu',
    friday: 'Friday',
    fridayShort: 'Fri',
    saturday: 'Saturday',
    saturdayShort: 'Sat',
    sunday: 'Sunday',
    sundayShort: 'Sun',
  },
  orderStatus: {
    none: 'Default',
    created: 'Created',
    in_preparation: 'In Preparation',
    ready: 'Ready',
    in_payment: 'In Payment',
    awaiting_confirmation: 'Awaiting Confirmation',
    done: 'Done',
    failed: 'Failed',
    validated: 'Validated',
    cancelled_by_waiter: 'Cancelled by Waiter',
    cancelled_by_customer: 'Cancelled by Customer',
  },
  checkoutIntegrationStatus: {
    sent: 'Sent',
    received: 'Received',
    verified: 'Verified',
    finalized: 'Finalized',
    rejected: 'Rejected',
    canceled: 'Canceled',
    postponed: 'Postponed',
  },
  stockMode: {
    none: 'Deactivated',
    toggle: 'Activated',
    disable_only: 'Only deactivate articles',
    enable_only: 'Only activate articles',
  },
  mainCategories: {
    dish: 'Dish',
    beverage: 'Beverage',
    other: 'Other',
  },
  autoReset: {
    none: 'None',
    morning: 'Morning',
    noon: 'Noon',
    evening: 'Evening',
    midnight: 'Midnight',
  },
  customerGroups: {
    default: 'default',
    defaultInPreparation: 'default_in_preparation',
    defaultWebApp: 'default_web_app',
    subway: 'Subway',
    db: 'Deutsche Bahn',
    lunchroom: 'Lunchroom',
    weilands: 'Weilands',
    cinemaxx: 'Cinemaxx',
    fbf: 'Food By Friends',
    district: 'District',
    slush: 'Slush',
    kochloeffel: 'Kochlöffel',
    immergruen: 'Immergrün',
    myMonza: 'MyMonza',
    subwayFr: 'Subway France',
    subwayLu: 'Subway Luxembourg',
    subwayTerminal: 'Subway Terminal',
    aspasia: 'Aspasia',
    cotidiano: 'Cotidiano',
    bigburger: 'BigBurger',
    koos: 'KOOS',
    deanAndDavid: 'Dean and David',
    frittenwerk: 'Frittenwerk',
    purino: 'Purino',
    ottosBurger: 'Otto´s Burger',
    threeMensKebab: '3 Mens Kebab',
    perfectDay: 'Perfect Day',
    hausmanns: 'Hausmanns',
    doenerwerk: 'Dönerwerk',
    foodlounge: 'Foodlounge',
    mado: 'Mado',
    depot: 'Depot',
    nordsee: 'Nordsee',
    jamies: 'Jamies',
    burgerKing: 'Burger King',
    burgerKingD: 'Burger King D',
    atlantikFisch: 'Atlantik Fisch',
    moschmosch: 'Moschmosch',
    kamps: 'Kamps',
    coffeeFellows: 'Coffee Fellows',
    hofbrauhaus: 'Hofbrauhaus',
    saray: 'Saray',
    starbucks: 'Starbucks',
    dimatest: 'Dima Test',
    maloa: 'Maloa',
    werk5: 'Werk 5',
    epi: 'EPI',
    iamlove: 'IAMLOVE',
    beetsAndRoots: 'Beets and Roots',
    beetsAndRootsSecond: 'Beets and Roots 2',
    losteria: "L'Osteria",
    losteriaAt: "L'Osteria Austria",
    shiso: 'Shiso',
    snackElize: 'Snack Elize',
    tabilo: 'TUR RES',
    tabiloSim: 'TUR Simphony',
    turAbnahmeRes: 'TUR Abnahme RES',
    turAbnahmeSim: 'TUR Abnahme Sim',
    turAutohof: 'TUR Autohof',
    turAbnahmeAutohof: 'TUR Abnahme Autohof',
    turSegafredo: 'TUR Segafredo',
    effeGold: 'Effe & Gold',
    lacantine: 'La cantine',
    eam: 'Eam',
    naupaka: 'Naupaka',
    sportsbar: 'Sportsbar',
    cigkoftem: 'Cigkoftem',
    sushisupply: 'Sushi Supply',
    the_ash: 'The Ash',
    markthalle: 'Markthalle',
    sashimi: 'Sashimi',
    bonboncha: 'Bonboncha',
    hulala: 'Hulala',
    backwerk_schweiz: 'Backwerk Schweiz',
    backwerkCh: 'Backwerk CH',
    backfactory: 'Backfactory',
    teedeli: 'Teedeli',
    wohlfuhler: 'Wohlfuhler',
    asiaGourmet: 'Asia Gourmet',
    frittenwerkSecond: 'Frittenwerk 2',
    ricerepublic: 'RiceRepublic',
    goodbytz: 'Goodbytz',
    piratenBurger: 'Piraten Burger',
    tournesol: 'Tournesol',
    brezelKoenig: 'Brezelkönig',
    vincentVegan: 'Vincent Vegan',
    papais: 'Papais',
    theCup: 'The Cup',
    marseilleFoodMarket: 'Marseille Food Market',
    olearys: 'Olearys',
    iceland: 'Iceland',
    tableDot: 'Table Dot',
    sevenByBat: 'Seven by BAT',
    breakBurger: 'Break Burger',
    wok: 'Wok',
    oakberry: 'Oakberry',
    trz: 'TRZ',
    monkeyBurger: 'Monkey Burger',
    pastaFee: 'Pasta Fee',
    potatoe: 'Potatoe',
    pibose: 'Pibosa',
    shiangMing: 'Shiang Ming',
    antonAndAnni: 'Anton&Anni',
    kaisin: 'Kaisin',
    dunkin: 'Dunkin',
    sushiTomo: 'Sushi Tomo',
    spiga: 'SPIGA',
    rastpark: 'Euro Rastpark',
    ahoi: 'Ahoi',
    eatdoori: 'Eatdoori',
    burroBurro: 'Burro Burro',
    brammibalDonuts: 'Brammibal Donuts',
    milanoVice: 'Milano Vice',
    sspSliceIt: 'SSP Slice It',
    keladamsKebab: 'Keladams Kebab',
    autohof24: 'Autohof 24',
    reishauer: 'Reishauer',
    pastaLich: 'Pasta Lich',
    eintrachtFrankfurt: 'Eintracht Frankfurt',
    topgolf: 'Topgolf',
    klausKebab: 'Klaus Kebab',
    josefs: 'Josefs',
    burritoCompany: 'Burrito Company',
    zeroKebab: 'Zero Kebab',
    nhasCityChicken: 'Nhas City Chicken',
    mrSha: 'Mr. Sha',
    bollwerk: 'Bollwerk',
    wyniger: 'Wyniger',
    burgerVision: 'Burger Vision',
    picklBurger: 'Pickl Burger',
    maisonMatcha: 'Maison Matcha',
    enriqueTomas: 'Enrique Tomas',
    versaillesCastle: 'Versailles Castle',
    randys: 'Randys',
    saz: 'Saz',
    hawaiianPokeBowls: 'Hawaiian Poke Bowls',
    luca: 'Luca',
    olearysNordic: "O'Learys Nordic",
    trattoriaTavolare: 'Trattoria Tavolare',
    carlsbergSportsBar: 'Carlsberg Sports Bar',
    bistro: 'Bistro',
    jomfruin: 'Jomfruin',
    rabbagast: 'Rabbagast',
    craftNDraft: 'Craft n Draft',
    herfra: 'Herfra',
    cafeRitazza: 'Cafe Ritazza',
    heineken: 'Heineken',
    laBoutique: 'La Boutique',
    vaerbitt: 'Vaerbitt',
    originalChicken: 'Original Chicken',
    tigerstaden: 'Tigerstaden',
    bjornsBackyard: 'Bjorns Backyard',
    burgerKingCh: 'Burger King CH',
    gelatoBar: 'Gelato Bar',
    sspVincentVegan: 'SSP Vincent Vegan',
    elKiosko: 'El Kiosko',
    camden: 'Camden',
    pizzaHut: 'Pizza Hut',
    spareRib: 'Spare Rib',
    sodai: 'Sodai',
    lucullus: 'Lucullus',
    bonbird: 'Bonbird',
    sspPizzaHut: 'SSP Pizza Hut',
    elevenBar: '11 Bar',
    theKissingGates: 'The Kissing Gates',
    gambrinus: 'Gambrinus',
    tabernnus: 'Tabernnus',
    jimis: 'Jimis',
    hensslerAtHome: 'Henssler At Home',
    dailyPizza: 'Daily Pizza',
    hunterBar: 'Hunter Bar',
    mogaTee: 'Moga Tee',
    grauholz: 'Grauholz',
    figlmueller: 'Figlmüller',
    dominosSwitzerland: 'Dominos Pizza CH',
    wildChildCoffee: 'Wild Child Coffee',
    asFoodCompany: 'As Food Company',
    smashKoenig: 'Smash Koenig',
    schurter: 'Schurter',
    dirtyPatty: 'Dirty Patty',
    captainHook: 'Captain Hook',
    ingerslevs: 'Ingerslevs',
    thaqiCafeNuernberg: 'Thaqi Cafe Nürnberg',
    aramarkAsianBistrotConcept: 'Aramark Asian Bistrot Concept',
    theBab: 'The Bab',
    locoChicken: 'Loco Chicken',
    eatery77: 'Eatery 77',
    beshle: 'Beshle',
    feasty: 'Feasty',
    kantine11: 'Kantine 11',
    foodBrother: 'Food Brother',
    pastalich: 'Pastalich',
    zagros: 'Zagros',
    montys: 'Montys',
    barinoRestaurant: 'Barino Restaurant',
    upstairsBar: 'Upstairs & Bar',
    eateryGarden: 'Eatery Garden',
    barBistro: 'Bar&Bistro',
    upperCrust: 'Upper Crust',
    oakBarrel: 'Oak Barrel',
    spizzaPizza: 'Spizza Pizza',
    kerb: 'Kerb',
    derDonerKebabhaus: 'Der Doner Kebabhaus',
    takkeh: 'Takkeh',
    acayaKoblenz: 'Acaya Koblenz',
    forzanapoliDe: 'Forzanapoli DE',
  },
  deliverableOrderTypes: {
    foodspot: 'Foodspot',
    delivery: 'Delivery',
  },
  error: {
    notFound: 'Sorry, the page could not be found.',
    forbidden: 'Forbidden.',
    goHome: 'Go Back to Start',
    forbiddenText: 'Unauthorized. You are not allowed to view this page.',
    notFoundText: "The page you are looking for couldn't be found.",
  },
  foodcard: {
    index: 'Manage Foodcard',
    export_csv: 'Export Foodcard (*.csv)',
    export_csv_de: 'DE Export Foodcard (*.csv)',
    import: 'Import Foodcard',
    importCvs: 'Import foodcard (*.csv)',
    importNutritionCsv: 'Import nutritions (*.csv)',
    export_xlsx_de: 'DE Export Foodcard (*.xlsx)',
    importCvsWithArticleInfo: 'Import info of Articles (*.csv)',
  },
  home: {
    index: 'Home',
    welcome: 'Welcome!',
  },
  tag: {
    index: 'Manage Tags',
    overview: 'Overview',
    add: 'Add Tag',
    empty:
      // tslint:disable-next-line:max-line-length
      "It looks like you haven't added any tags yet. Create your first tag to assign them to your articles and options.",
    form: {
      name: 'Name',
      identifier: 'Identifer',
      sort: 'Sort',
      recommendationTag: 'Recommendation Tag',
    },
    table: {
      name: 'Name',
      identifier: 'Identifier',
      sort: 'Sort',
      recommendationTag: 'Recommendation Tag',
    },
  },
  depositRule: {
    index: 'Manage Deposit Rules',
    overview: 'Overview',
    add: 'Add Deposit Rule',
    empty: "It looks like you haven't added any deposit rules yet. Create your first deposit rule.",
    form: {
      priority: 'Prioirity',
      deposit: 'Deposit',
      startedAt: 'From',
      endedAt: 'To',
    },
    table: {
      priority: 'Prioirity',
      deposit: 'Deposit',
      startedAt: 'From',
      endedAt: 'To',
    },
  },
  information: {
    index: 'Manage Information',
    overview: 'Overview',
    add: 'Add Information',
    edit: 'Edit Information',
    addAction: 'Add Action',
    removeAction: 'Remove Action',
    actions: 'Actions',
    empty:
      "It looks like you haven't added any information yet. Create your first information to inform customers about upcoming events and promos.",
    actionTypes: {
      primary: 'Primary',
      secondary: 'Secondary',
      cancel: 'Cancel',
    },
    form: {
      image: 'Image',
      title: 'Title',
      from: 'From',
      to: 'To',
      description: 'Description',
      url: 'Url',
      action: 'Action',
      actionType: 'Action Type',
      actionValue: 'Action Value',
      actionHtmlContent: 'HTML Content',
      actionName: 'Action Name',
    },
    table: {
      title: 'Title',
      description: 'Description',
      from: 'From',
      to: 'To',
      url: 'Url',
    },
  },
  role: {
    index: 'Manage Roles',
    overview: 'Overview',
    create: 'Create Role',
    edit: 'Edit Role',
    copy: 'Copy Role',
    empty: "It looks like you haven't created any roles yet. Create your first role to give users granular access.",
    help: 'Attention! Only change a role if you are absolutely sure, what are you doing. Also note that system roles cannot be changed.',
    add: 'Add Role',
    table: {
      name: 'Name',
      slug: 'Slug',
      isSystem: 'System Role',
      permissions: 'Permissions',
    },
    form: {
      name: 'Name',
      slug: 'Slug (unique identifier)',
      isSystem: 'System role (if active, role cannot be changed.)',
      permissions: 'Permissions',
    },
    notification: {
      roleCopyStarted:
        'Role copy process has started. You will be redirected to the Role Creation page with prefilled data. Please apply any changes if needed and click Save.',
      roleCopyFailed: 'Role copy process failed. Please try again.',
    },
  },
  customerGroupProprty: {
    index: 'Manage Customer Group Property',
    overview: 'Overview',
    create: 'Create Customer Group Proprty',
    edit: 'Edit Customer Group Property',
    add: 'Add Customer Group Property',
    importTemplate: 'Import Customer Invoice Template',
    table: {
      name: 'Name',
      template: 'Invoice Template',
      defaultOrderStatus: 'Default Order Status',
      initialOrderStatusStandard: 'Initial OrderStatus Standard',
      initialOrderStatusTerminal: 'Initial Order Status Terminal',
    },
    form: {
      customerGroupName: 'Name',
      getDefaultOrderStatus: 'Default Order Status',
      getInitialOrderStatusStandard: 'Initial Order Status Standard',
      getInitialOrderStatusTerminal: 'Initial Order Status Terminal',
      getInitialOrderStatusVirtual: 'Initial Order Status Virtual',
    },
  },
  venueLabel: {
    index: 'Manage Venue Labels',
    overview: 'Overview',
    create: 'Create Venue Label',
    edit: 'Edit Venue Label',
    empty: "It looks like you haven't created any venue labels yet.",
    add: 'Add Label',
    table: {
      name: 'Name',
      slug: 'Slug',
      venues: 'Venues',
    },
    form: {
      name: 'Name',
      image: 'Image',
      slug: 'Slug (unique identifier)',
      venues: 'Venues',
      visibleTo: 'Visible to Venues',
    },
  },
  recommendation: {
    index: 'Cart Recommendation',
    create: 'Create Cart Recommendation',
    edit: 'Edit Cart Recommendation',
    overview: 'Overview',
    score: 'Score',
    scoreMatrix: 'Score Matrix',
    scoreMatrixNotFound: 'Score Matrix not found',
    best: 'Best',
    worst: 'Worst',
  },
  user: {
    index: 'Manage Users',
    overview: 'Overview',
    create: 'Create User',
    adminCreateWarning: 'Warning: You are trying to create a user with admin role.',
    adminCreateConfirm: 'Are you really sure you want to create an admin user?',
    changePassword: 'Change Password',
    help: 'Attention! Only change a user if you are absolutely sure, what are you doing. Otherwise a user may not be able to login.',
    edit: 'Edit User',
    add: 'Add User',
    table: {
      name: 'Name',
      email: 'E-Mail',
      code: 'Code',
      venues: 'Venues',
      role: 'Role',
    },
    form: {
      name: 'Name',
      customerGroup: 'Customer Group',
      linkedCustomerGroup: 'Linked Customer Group',
      email: 'E-Mail',
      password: 'Password',
      passwordConfirmation: 'Password Confirmation',
      venues: 'Venues',
      venueLabels: 'Venue Labels',
      role: 'Role',
    },
  },
  printer: {
    index: 'Manage Printers',
    overview: 'Overview',
    edit: 'Edit Printer',
    customerGroup: 'Customer Group',
    empty: "It looks there aren't any printers yet.",
    table: {
      name: 'Name',
      articleCount: 'Number of Articles',
      venue: 'Venue',
      startedAt: 'Started at',
      activated: 'Activated',
      lastSignal: 'Last Signal',
      latestActivity: 'Latest Activity',
      restart: 'Restart',
      restartInProgress: 'Restart in progress...',
      order: 'Order',
    },
    form: {
      articles: 'Articles',
      name: 'Name',
    },
  },
  customer: {
    index: 'Manage Customers',
    overview: 'Overview',
    edit: 'Edit Customer',
    create: 'Create Customer',
    add: 'Add Customer',
    import: 'Import Customer',
    empty: "It looks like you havent' added any customers yet. Create your first customer.",
    table: {
      userUid: 'User UID',
      name: 'Name',
      email: 'E-Mail',
      qr: 'QR-Code',
    },
    form: {
      email: 'E-Mail',
      gender: 'Gender',
      name: 'Full Name',
      city: 'City',
      street: 'Street',
      number: 'Number',
      postalCode: 'Postal Code',
    },
  },
  constrain: {
    index: 'Manage Tradegroups',
    overview: 'Overview',
    add: 'Add Tradegroup',
    empty:
      "It looks like you haven't added any tradegroups yet. Create your first tradegroup to assign them to your articles.",
    form: {
      name: 'Name',
      identifier: 'Identifer',
      active: 'Active',
    },
    table: {
      name: 'Name',
      identifier: 'Identifier',
      active: 'Active',
    },
  },
  printGroups: {
    index: 'Manage Printgroups',
    overview: 'Overview',
    add: 'Add Printgroups',
    empty:
      "It looks like you haven't added any Printgroups yet. Create your first Printgroups to assign them to your articles.",
    form: {
      name: 'Name',
      identifier: 'Identifer',
      active: 'Active',
    },
    table: {
      name: 'Name',
      identifier: 'Identifier',
      active: 'Active',
    },
  },
  languages: {
    de: 'German',
    en: 'English',
    fr: 'French',
    nl: 'Dutch',
    it: 'Italian',
    pl: 'Polish',
    es: 'Spanish',
    tr: 'Turkish',
    zh: 'Chinese',
    ru: 'Russian',
    da: 'Danish',
    ja: 'Japanese',
    is: 'Icelandic',
    pt: 'Portuguese',
    cz: 'Czech (DO NOT USE)',
    cs: 'Czech',
    ar: 'Arabic',
    el: 'Greek',
    ko: 'Korean',
    th: 'Thai',
    vi: 'Vietnamese',
    hi: 'Hindi',
    ur: 'Urdu',
    tl: 'Tagalog',
    id: 'Indonesian',
    no: 'Norwegian',
    sv: 'Swedish',
    lt: 'Lithuanian',
    fi: 'Finnish',
  },
  legalForms: {
    ag: 'AG',
    gmbh: 'GmbH',
    ltd: 'UG',
    kg: 'KG',
    pe: 'Einzelgesellschaft',
    other: 'Andere',
    sa: 'SA',
    sarl: 'SARL',
    eurl: 'EURL',
    sas: 'SAS',
    autres: 'AUTRES',
    se: 'SE',
    seCoKg: 'SE & Co. KG',
  },
  periods: {
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    never: 'Never',
  },
  locTypes: {
    bar: 'Bar',
    club: 'Club',
    restaurant: 'Restaurant',
    db: 'Deutsche Bahn',
    cinema: 'Cinema',
    other: 'Other',
  },
  paymentTypes: {
    cc: 'Credit Card',
    pp: 'PayPal',
    sepa: 'SEPA',
    sb: 'Sofort Banking',
    bankTransfer: 'Bank Transfer',
    paypal: 'PayPal',
    cash: 'Cash',
    credit_card: 'Credit Card',
    balance: 'Balance',
    pos: 'POS',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    sofortbanking: 'Sofort Banking',
    wallee: 'Wallee',
    postfinance: 'PostFinance',
    postfinance_card: 'PostFinance Card',
    reka: 'Reka',
    twint: 'Twint',
    luncheck: 'Luncheck',
    boncard: 'Boncard',
    alipay: 'Alipay',
    wechat: 'WeChat Pay',
    worldline: 'Worldline',
    worldline_raw: 'Worldline (Raw)',
    tac: 'TAC',
    ccv: 'CCV',
    zero_payment: 'Zero Payment',
    wolt: 'Wolt',
    ec: 'EC',
    girocard: 'Girocard',
    mastercard: 'Mastercard',
    amex: 'American Express',
    visa: 'Visa',
    visa_e: 'Visa Electron',
    vpay: 'V PAY',
    jcb: 'JCB',
    maestro: 'Maestro',
    other: 'Other',
    vr_sepa: 'VR SEPA',
    bank_transfer: 'Bank Transfer',
    diners: 'Diners Club',
    discover: 'Discover',
    subsidy: 'Subsidy',
    piggy_gift_card: 'Piggy Gift Card',
    piggy_prepaid_balance: 'Piggy Prepaid Balance',
    como_gift_card: 'Como Gift Card',
    miles_and_more: 'Miles & More',
    kost_card: 'KOST Card',
    worldline_mobile_apple_pay: 'Worldline Mobile Apple Pay',
    worldline_mobile_credit_card: 'Worldline Mobile Credit Card',
    worldline_mobile_google_pay: 'Worldline Mobile Google Pay',
    worldline_apple_pay: 'Worldline Apple Pay',
    worldline_credit_card: 'Worldline Credit Card',
    worldline_google_pay: 'Worldline Google Pay',
    ideal: 'iDEAL',
    meal_voucher_fr: 'Meal Voucher (FR)',
    bon_bon_gift_card: 'Bon Bon Gift Card',
    deliveroo: 'Deliveroo',
    swish: 'Swish',
    vipps: 'Vipps',
    mobile_pay: 'Mobile Pay',
    dankort: 'Dankort',
    maxxvend: 'MAXXvend',
  },
  nav: {
    smoothrPay: 'Smoothr Pay',
    smoothrPayMerchants: 'Merchants',
    smoothrPayPayments: 'Payments',
    smoothrPayPayouts: 'Payouts',
    smoothrPayReports: 'Reports',
    dashboard: 'Dashboard',
    auditing: 'Auditing',
    enrollments: 'Enrollments',
    foodcard: 'Foodcard',
    customer: 'Customers',
    screensaver: 'Screensaver',
    venue: 'Venues',
    venueLabel: 'Venue Labels',
    productCombos: 'Product Combos',
    payment: 'Payments',
    user: 'User',
    table: 'Tables',
    tag: 'Tags',
    information: 'Information',
    sales: 'Sales',
    salesOverview: 'Sales Overview',
    printer: 'Printer',
    translation: 'Translation',
    tradegroup: 'Tradegroups',
    printGroups: 'Print Groups',
    provision: 'Provision',
    inventory: 'Inventory',
    statistic: 'Statistics',
    analytic: 'Analytics',
    receipts: 'Receipts',
    billing: 'Billing',
    userExport: 'User export',
    selectVenue: 'Select venue',
    category: 'Categories',
    subscriptionCategories: 'Sub. Category',
    subscription: 'Subscription',
    membership: 'Membership level',
    article: 'Articles',
    articleManager: 'Articles & Options Visibility',
    recommendations: 'Recommendations',
    option: 'Options',
    reporting: 'Reporting',
    import: 'Import',
    role: 'Role',
    sepa: 'SEPA',
    maintenance: 'Maintenance',
    promo: 'Promo Codes',
    banner: 'Banners',
    tips: 'Tips',
    eposJobs: 'Epos jobs',
    automatedReport: 'Automated Reports',
    coupon: 'Coupon (deprecated)',
    employeeNotification: 'Employee Notification',
    loyaltyPrograms: 'Loyalty Program',
    comoManagedGifts: 'Como Managed Gifts',
    seasonPass: 'Season Pass',
    automatedReports: 'Automated Reports',
    customerGroupProprty: 'Customer Group',
    sanifairLogs: 'Sanifair Logs',
    cupCode: 'Cup codes',
    activityLogExport: 'Activity Log Export',
    sync: 'Sync',
    aggregatorSyncs: 'Aggregation Sync',
    posSync: 'POS Sync',
    injectionRates: 'Injection Rates',
    company: 'Companies',
    promocodesAndLoyalty: 'Loyalty',
    customerInfo: 'Customer info',
    other: 'Other',
    finances: 'Finances',
    analytics: 'Analytics',
    syncAndLogs: 'Sync and Logs',
    uiComponents: 'UI Components',
    uiSlides: 'Slides',
    uiSlider: 'Slider',
    uiCard: 'Card',
    uiBanner: 'Banner',
    campaigns: 'Campaigns',
    releases: 'Releases',
    upsell: 'Upsells',
    depositRule: 'Deposit Rules',
    healthCheck: 'Healthcheck',
  },
  auth: {
    logout: 'Logout',
    login: 'Login',
    forgotPassword: 'Forgot Password',
    forgotPasswordHint: 'Please enter your e-mail and click reset passsord.',
    resetPassword: 'Reset Password',
    reset: 'Reset Password',
    security: 'Account security',
    form: {
      password: 'Password',
      passwordHint:
        'The password must contain at least 8 characters, 1 capital letter and 1 number or special character.',
      passwordConfirmation: 'Password Confirmation',
      email: 'Email',
      otp: 'One time code',
    },
    mfaModal: {
      title: 'Approval required',
      description: 'Enter your MFA code',
    },
    accountSecurity: {
      title: 'Kontosicherheit',
      mfa: {
        title: 'Multi-factor-authentication (MFA)',
        description:
          'The multi-factor-authentication adds an extra layer of security to your account by requiring more than just the password for login and critical functions.',
        setup: 'Set up Authenticator app',
        scan: 'Scan the QR code with your Authenticator app.',
        enterCode: 'After scanning the QR code, the app will show you a code. Enter this code below.',
        enterCodeShort: 'Enter your MFA code:',
        backupCodesTitle: 'Backup-Codes',
        backupCodesExplanation:
          'If multifactor authentication is active and you lose your device, you will need the backup codes to access your Lemin account.',
        backupCodesDanger:
          'Without backup codes, you will need to contact our support and provide appropriate proof so that your Lemin account can be reactivated. <br/><br/> We recommend that you download or copy the backup codes and keep them in a safe place. Each backup code is only valid once and will be removed after use.',
        copy: 'Copy',
        download: 'Download',
        print: 'Print',
        status: 'Status',
        active: 'Active',
        notActive: 'Not active',
        deactivate: 'Deactivate',
        showBackupCodes: 'Sho backup codes',
        regenerateBackupCodes: 'Regenerate backup codes',
        deactivateMFATitle: 'Deactivate multi-factor-authentication',
        deactivateMFADanger:
          'To use multi-factor-authentication again, you must set it up again. Existing backup codes will be deleted after deactivation. <br/><br/>Are you sure you want to continue?',
      },
    },
    notification: {
      forgotPassword:
        'If we have found your e-mail in our system, we will send you an email with a link to reset your password',
      resetPassword: 'Your password has been reset.',
      forbidden: "You don't have permission to view this page.",
      login: 'You have successfully logged in.',
      logout: 'You have successfully logged out.',
      resetPasswordError: 'Either your token could not be found or the token is expired.',
      invalidMFACode: 'The MFA code is invalid.',
    },
  },
  maintenance: {
    index: 'Maintenance',
    status: 'Maintenance status',
    enable: 'Enable Maintenance',
    disable: 'Disable Maintenance',
    enabled: 'System is currently running in maintenance mode. Some service may not be available.',
    disabled: 'All systems are working fine.',
  },
  register: {
    index: 'Registration',
    account: 'Account',
    register: 'Register',
    success: 'Registration Success',
    addVenue: 'Add Venue',
    removeVenue: 'Remove Venue',
    venue: 'Create Venues',
    documentInfo:
      'Please fill out the following data to generate your imprint, terms and conditions and privacy policy for your webshop. These documents are necessary.',
    successText: 'Your registration was successful. We will inform you via email, when your venues are created.',
    location: 'Location Details',
    invoiceReceiver: 'Invoice Receiver',
    dialog: {
      venue: 'Would you like to create a venue? If you click no, you can still do this later.',
    },
    form: {
      venue: 'Venue',
      name: 'Full Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone',
      email: 'E-Mail',
      password: 'Password (min. 6)',
      passwordHint:
        'The password must contain at least 8 characters, 1 capital letter and 1 number or special character.',
      passwordConfirmation: 'Password Confirmation (min. 6)',
      privacy: 'I accept the Data Protection Regulations',
      privacyLink: 'Data Protection Regulations',
    },
    notification: {
      venue:
        'Your new Venue will be added in a few minutes. Please logout and login in 3 minutes to see and edit your new venue.',
    },
  },
  article: {
    index: 'Manage Articles',
    create: 'Create a new Article',
    edit: 'Edit Article',
    copy: 'Copy Article',
    testFoodcard: 'Test foodcard',
    add: 'Add Article',
    availability: 'Availability',
    overview: 'Overview',
    selectArticle: 'Select Article',
    selectCategory: 'Please Select Category',
    general: 'General',
    prices: 'Prices',
    visibility: 'Visible',
    meta: 'Meta',
    measurement: 'Measurement',
    media: 'Media',
    options: 'Options',
    displayPrices: 'Display Prices',
    mappings: 'Article Mappings',
    requirements: 'Article Requirements',
    nutritions: 'Article nutritions',
    defaults: 'Article Defaults',
    recommendations: 'Article Recommendations',
    depArticles: 'Articles',
    availableHours: 'Available Hours',
    addGroupDependency: 'Add Dependency',
    addGroupReverseDependency: 'Add Reverse Dependencies',
    addMappingArticle: 'Add Mapping Article',
    addDepArticles: 'Add Dependency Articles',
    addReverseDepArticles: 'Add Reverse Dependency Articles',
    dependencies: 'Dependencies',
    reverseDependencies: 'Reverse dependencies',
    addDefault: 'Add Default',
    split: 'Split',
    standardPrices: 'Standard Prices',
    preorderPrices: 'Preorder Prices',
    terminalPrices: 'Terminal Prices',
    standardAvailability: 'Standard Availability',
    terminalAvailability: 'Terminal Availability',
    preorderAvailability: 'Preorder Availability',
    priceLockByType: 'Prices lock by order type (general price lock has precedence)',
    webAvailability: 'Web Availability',
    cateringAvailability: 'Catering Availability',
    noVisibleArticlesNotice: 'Sorry! This option group has no visible articles.',
    addRecommendation: 'Add Recommendation',
    price: 'Price',
    priceLowToHigh: 'Low to high',
    priceHighToLow: 'High to low',
    visible: 'Visible',
    hide: 'Hide',
    fontColor: 'Font Color',
    styleOption: 'Style Options',
    borderColor: 'Border Color',
    backgroundColor: 'Background Color',
    style: 'Styles',
    loyaltyOptions: 'Loyalty Options',
    openingHours: 'Opening Hours',
    manufacturer: 'Manufacturer',
    ingredients: 'Ingredients',
    dimension: 'Dimensions',
    weightDetails: 'Weight Details',
    seeOriginal: 'See original article',
    displayIdentifiersOfOptions: 'Display identifiers of options',
    tagsOfArticle: 'Tags of article',
    helloTess: {
      hellotessApiBaseUrl: 'helloTESS! api url',
      hellotessApiKey: 'helloTESS! api key',
      success: 'Foodcard was imported',
    },
    gastrofix: {
      gastrofixBusinessUnit: 'Business Unit',
      gastrofixApiKey: 'Gastrofix api key',
      gastrofixImportLanguage: 'Foodcard Language',
      success: 'Foodcard was imported',
    },
    simphony: {
      orgShortName: 'Organisation Identifier/Short Name',
      locRef: 'Location Identifier',
      rvcRef: 'Revenue Center Identifier',
      serviceUrl: 'Service URL',
      importLanguage: 'Foodcard Language',
      success: 'Foodcard was imported',
    },
    deliverect: {
      account: 'Deliverect Customer Account ID',
      menu: 'Menu ID',
      importLanguage: 'Foodcard Language',
      success: 'Foodcard was imported',
    },
    generalImport: {
      checkoutIntegration: 'Foodcard',
    },
    tabs: {
      general: 'General',
      media: 'Media',
      meta: 'Meta',
      options: 'Options',
      prices: 'Prices',
      displayPrices: 'Display Prices',
      availableHours: 'Available Hours',
      availability: 'Availability',
      allergens_and_additives: 'Allergens and Additives',
      nutritions: 'Nutritions',
      features: 'Features',
      style: 'Styles',
      wolt: 'Wolt',
      uberEats: 'Uber-Eats',
      jet: 'Jet',
      deliveroo: 'Deliveroo',
      visibility: 'Visibility',
    },
    table: {
      name: 'Name',
      stock: 'Stock',
      price: 'Price',
      active: 'Active',
      assets: 'Image',
      internalNote: 'Internal Note',
      internalName: 'Internal Name',
      category: 'Category',
      isControlArticle: 'Control Article',
      availableHours: 'Available Hours',
      categoryAvailableHours: 'Category Available Hours',
      icon: 'Icon',
      banner: 'Banner',
      description: 'Description',
      number: 'Number',
      sortOrder: 'Sort',
      gtin: 'GTIN',
      visible: 'Visible',
      rowsPerPage: 'Rows Per Page',
      externalId: 'External Id',
      preorderDeliveryPrice: 'Preorder Delivery Price',
      preorderTakeAwayPrice: 'Preorder TakeAway Price',
      terminalTakeAwayPrice: 'Terminal TakeAway Price',
      terminalInsidePrice: 'Termina Inside Price',
      tags: 'Tags',
      taxTakeaway: 'Tax Takeaway',
      taxInside: 'Tax Inside',
      uber: 'Uber-Eats',
      wolt: 'Wolt',
      jet: 'Jet',
      uberEatsTakeawayEnabled: 'Uber Eats Takeaway Available',
      uberEatsDeliveryEnabled: 'Uber Eats Delivery Available',
      woltVisibility: 'Wolt Visibility',
      woltActive: 'Wolt Active',
      jetTakeawayEnabled: 'Jet Takeaway Available',
      jetDeliveryEnabled: 'Jet Delivery Available',
    },
    copyDialog: {
      sourceCategory: 'Source Category',
      targetCategory: 'Target Category',
      articles: 'Articles',
      venue: 'Select Venue',
      success: 'Article(s) was copied',
    },
    testFoodcardModal: {
      chunkSize: 'Count of articles per order',
      success: 'Foodcard test has been successfully started.',
      error: 'Foodcard test could not be started.',
    },
    form: {
      name: 'Name',
      internalName: 'Internal Name',
      description: 'Description',
      price: 'Price',
      prices: 'Prices',
      type: 'Type',
      value: 'Value',
      emailDomain: 'E-Mail domain',
      bannerVideo: 'Video',
      kostPrice: 'KOST Price',
      maxxvendPrice: 'Maxxvend Price',
      dndCompany: 'DND Company',
      min: 'Min.',
      max: 'Max.',
      standardPrice: 'Standard Price',
      insidePrice: 'Inside Price',
      enabledInFoodcard: 'Active (if not active, the item will not be added to the Wolt menu)',
      deliveryPrice: 'Delivery Price',
      takeAwayPrice: 'Take Away Price',
      replacesMainArticle: 'Replaces Main Article',
      gtin: 'GTIN (Global Trade Identifier Number)',
      externalId: 'External ID',
      internalNote: 'Internal Note',
      preparationTime: 'Preparation Time (in minutes)',
      plu: 'PLU',
      standardAvailability: 'Available',
      insideAvailability: 'Available inside',
      takeAwayAvailability: 'Available for take away',
      deliveryAvailability: 'Available for delivery',
      webAvailability: 'Available',
      stock: 'Stock',
      image: 'Image',
      banner: 'Banner',
      icon: 'Icon',
      active: 'Active',
      tags: 'Tags',
      group: 'Optiongroup',
      mainRecommendations: 'Main Recommendations',
      priceIsLocked: 'Price Locked (all)',
      isNoticeable: 'Noticeable',
      isControlArticle: 'Control Article',
      shortDescription: 'Short Description',
      articles: 'Articles',
      article: 'Article',
      visible: 'Visible',
      printerSort: 'Printer Sort',
      quantity: 'Quantity',
      constrains: 'Tradegroups',
      printGroups: 'Printgroups',
      unit: 'Unit',
      amount: 'Amount',
      rateable: 'Rateable',
      taxInside: 'Tax Inside',
      taxTakeaway: 'Tax Takeaway',
      takeaway: 'Takeaway',
      delivery: 'Delivery',
      inside: 'Inside',
      displayPrice: 'Display Price',
      referencePrice: 'Reference Price',
      referencePriceHint:
        'Regular selling price of the article. For deal articles, "Price" holds the deal price — enter the normal price here so the original price and discount are reported correctly.',
      isPrintable: 'Printable',
      isRateable: 'Rateable',
      info: 'Info',
      sort: 'Sort',
      mappedArticle: 'Mapped Article',
      code: 'Code',
      category: 'Category',
      number: 'Number',
      deposit: 'Deposit',
      fsk: 'FSK',
      alcoholPercentage: 'Alkohol (in Percentage)',
      caffeineMg: 'Caffeine (mg)',
      main: 'Main Article',
      kcal: 'Kcal',
      options: 'Options',
      optionGroup: 'Option Group',
      newName: 'New Name',
      availableDateStart: 'Available Date Start',
      availableDateEnd: 'Available Date End',
      maxItemsPerCart: 'Max. Items per Cart',
      articleRelativeBrand: 'Brand',
      loyaltyId: 'Loyalty Id',
      isPiggyLoyalty: 'Is Piggy Loyalty',
      redeemableAtCheckoutOnly: 'Redeemable',
      piggyPointsNeeded: 'Piggy Points Needed (deprecated)',
      piggyRewardUuid: 'Piggy Reward Uuid',
      requiredLoyaltyPoints: 'Required loyalty points for redemption',
      address: 'Address',
      country: 'Country',
      visibility: 'Visibility',
      company: 'Company',
      height: 'Height (cm)',
      width: 'Width (cm)',
      length: 'Length (cm)',
      weight: 'Weight (g)',
      foodInstructions: 'Food Instructions',
      storageInstructions: 'Storage Instructions',
      providerImage: 'Image',
      priceLockByType: {
        standard: 'Standard',
        terminal: 'Terminal',
        preorder: 'Preorder',
        inside: 'Price locked for inside',
        takeAway: 'Price locked for take away',
        delivery: 'Price locked for delivery',
      },
      allergenes: {
        allergenes: 'Allergenes',
        cerealsWithGluten: 'Cereals Containing Gluten',
        crustaceans: 'Crustaceans and products thereof',
        eggs: 'Eggs and products thereof',
        fish: 'Fish and products thereof',
        peanuts: 'Peanuts and products thereof',
        soya: 'Soya (beans) and products thereof',
        milk: 'Milk and products thereof',
        nuts: 'Nuts',
        celery: 'Celery and products thereof',
        mustard: 'Mustard and products thereof',
        sesame: 'Sesame seeds and products thereof',
        lupins: 'Lupins and products thereof',
        molluscs: 'Molluscs and products thereof',
        corn: 'Corn and products thereof',
        wheat: 'Wheat and products thereof',
        rye: 'Contains wheat and products derived from it',
        barley: 'Barley and products thereof',
        oats: 'Oats and products thereof',
        spelt: 'Spelt and products thereof',
        khorasan: 'Khorasan and products thereof',
        walnuts: 'Walnuts and products thereof',
        pecanNuts: 'Pecan nuts and products thereof',
        brazilNuts: 'Brazil nuts and products thereof',
        pistachioNuts: 'Pistachio nuts and products thereof',
        macadamiaNuts: 'Macadamia nuts and products thereof',
        almonds: 'Almonds and products thereof',
        hazelnuts: 'Contains hazelnuts and products made from them',
        cashews: 'Cashews and products thereof',
        seeds: 'Seeds and products thereof',
        poppySeeds: 'Poppy seeds and products thereof',
        sunflowerSeeds: 'Sunflower seeds and products thereof',
        poultryMeat: 'Poultry meat and products thereof',
        beef: 'Beef and products thereof',
        pigmeat: 'Pigmeat and products thereof',
        yeast: 'Yeast extract',
        sulfurDioxideAndSulphites: 'Contains sulfur dioxide and sulfites and products derived therefrom',
        rye2: 'Contains rye and products derived from rye',
        gluten: 'Gluten',
      },
      additives: {
        additives: 'Additives',
        1: 'with dye',
        2: 'with preservative',
        3: 'with antioxidant',
        4: 'with flavor enhancer',
        5: 'contains sulfites',
        6: 'blackened',
        7: 'with phosphate',
        8: 'with milk protein (for meat products)',
        9: 'caffeinated',
        10: 'quinine',
        11: 'with sweetener',
        12: 'waxed',
        13: 'new',
        14: 'contains Alcohol',
        15: 'contains rye and products made from it',
        16: 'with nitrite curing salt',
        17: 'acidity regulator',
        18: 'stabilizer',
        19: 'acidifier',
      },
      traces: {
        traces: 'Traces',
        sesame: 'may contain traces of sesame and products thereof',
        soy: 'may contain traces of soy and products derived from it',
        peanuts: 'may contain traces of peanuts and products made from them',
        wheat: 'may contain traces of wheat and products made from it',
        lupins: 'may contain traces of lupins and products made from them',
        treeNuts: 'may contain traces of tree nuts and products made from them',
        sulfurDioxide: 'may contain traces of sulfur dioxide and sulfites and products derived from them',
        fish: 'may contain traces of fish and products made from them',
        milk: 'may contain traces of milk and products derived from it',
        eggs: 'may contain traces of eggs and products derived from it',
        mustard: 'may contain traces of mustard and products made from them',
        barley: 'may contain traces of barley and products made from them',
      },
      nutrition: {
        portionInG: 'Serving size (g)',
        portionInML: 'Serving size (ml)',
        energyKcalPerPortion: 'Energy (kcal)',
        energyKcalPer100G: 'Energy (kcal/100g)',
        energyKcalPer100ML: 'Energy (kcal/100ml)',
        energyKjPerPortion: 'Energy (kj)',
        energyKjPer100G: 'Energy (kj/100g)',
        energyKjPer100ML: 'Energy (kj/100ml)',
        fatPerPortion: 'Fat (g)',
        fatPer100G: 'Fat (g/100g)',
        fatPer100ML: 'Fat (g/100ml)',
        saturatesPerPortion: 'Saturates (g)',
        saturatesPer100G: 'Saturates (g/100g)',
        saturatesPer100ML: 'Saturates (g/100ml)',
        carbohydratePerPortion: 'Carbohydrate (g)',
        carbohydratePer100G: 'Carbohydrate (g/100g)',
        carbohydratePer100ML: 'Carbohydrate (g/100ml)',
        sugarPerPortion: 'Sugar (g)',
        sugarPer100G: 'Sugar (g/100g)',
        sugarPer100ML: 'Sugar (g/100ml)',
        proteinPerPortion: 'Protein (g)',
        proteinPer100G: 'Protein (g/100g)',
        proteinPer100ML: 'Protein (g/100ml)',
        saltPerPortion: 'Salt (g)',
        saltPer100G: 'Salt (g/100g)',
        saltPer100ML: 'Salt (g/100ml)',
        highFat: 'High Fat Content',
        highSugar: 'High Sugar Content',
      },
      features: {
        basic: 'Basic',
        features: 'Features',
        vegan: 'Vegan',
        vegetarian: 'Vegetarian',
        glutenFree: 'Gluten free',
        noCarb: 'Carbohydrate-free',
        alkaline: 'Alkaline',
        lactoseFree: 'Lactose free',
        new: 'New',
        special: 'Special',
        topSelling: 'Top seller',
        warm: 'Warm',
        cold: 'Cold',
        fish: 'Fish',
        chicken: 'Chicken',
        beef: 'Beef',
        pork: 'Pork',
        prepackaged: 'Prepackaged',
        protein: 'High in protein',
        healthy: 'Healthy',
        menu: 'Menu',
        sticker: 'Sticker',
        spicyLevel: {
          label: 'Spiciness level',
          light: 'Spicy',
          medium: 'Very spicy',
          extra: 'Extra spicy',
        },
      },
    },
  },
  articleManager: {
    index: 'Articles & Options Visibility',
    overview: 'Overview',
    mainArticle: 'Main Articles',
    optionArticle: 'Option Articles',
    options: 'Options',
    deactivateAll: 'Deactivate All',
    activateAll: 'Activate All',
    onlyOne: 'No, only this one',
    wolt: 'Wolt',
    uberEats: 'Uber-Eats',
    jet: 'Jet',
    filter: {
      category: 'Choose Category',
      status: 'Choose Status of Article',
      type: 'Article or Option Article',
      search: 'Search',
      allStatus: 'All',
      active: 'Visible',
      notActive: 'Invisible',
      article: 'Article',
      options: 'Options',
    },
    table: {
      visibility: 'Visibility',
      name: 'Name',
      category: 'Category',
      options: 'Options',
      price: 'Price',
      optionGroup: 'Option Group',
      connectedArticles: 'Connected articles',
      description: 'Description',
      loadMore: 'Load more',
    },
    notification: {
      saved: 'Changes saved.',
      sameArticleNumber:
        'We found articles with the same article number. Would you like to activate/deactivate (depending on the action) all of them, or only this one?',
    },
  },
  translation: {
    start: 'Translation started. This can take up to 10 minutes',
    index: 'Translation',
    overview: 'Overview',
    translate: 'translate',
    languages: {
      en: 'English',
      de: 'German',
      fr: 'French',
      nl: 'Dutch',
      it: 'Italian',
      pl: 'Polish',
      es: 'Spanish',
      zh: 'Chinese',
      ru: 'Russian',
      tr: 'Turkish',
      da: 'Danish',
      ja: 'Japanese',
      is: 'Icelandic',
      pt: 'Portuguese',
      cz: 'Czech',
      ar: 'Arabic',
      el: 'Greek',
      ko: 'Korean',
      th: 'Thai',
      vi: 'Vietnamese',
      hi: 'Hindi',
      ur: 'Urdu',
      tl: 'Tagalog',
      id: 'Indonesian',
      no: 'Norwegian',
      sv: 'Swedish',
      lt: 'Lithuanian',
      fi: 'Finnish',
    },
  },
  payment: {
    index: 'Payments',
    overview: 'Overview',
    refundArticle: 'Refund Article',
    refundArticleSmoothr: 'Refund Article Smoothr Only',
    refundOrder: 'Refund Order',
    refundOrderSmoothr: 'Refund Order Smoothr Only',
    refundPosOnly: 'Refund Order POS Only',
    refundQuestion: 'Are you sure you want to refund? This action cannot be undone.',
    refunded: 'Is part of a refund',
    order: 'Order',
    refund: 'Refunds available',
    searchCode: 'Search by order code...',
    searchTransactionId: 'Search by transaction id...',
    sendInvoice: 'Send invoice',
    showLogs: 'Show Logs',
    hideLogs: 'Hide Logs',
    logs: {
      logs: 'Logs',
      noLogs: 'No logs available for this payment.',
      payment: 'Payment',
      provider: 'Payment Provider',
      venue: 'Venue',
      messageType: 'Message Type',
      httpMethod: 'HTTP Method',
      httpStatusCode: 'HTTP Status Code',
      url: 'URL',
      endpoint: 'Endpoint',
      result: 'Result',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      expiresAt: 'Expires At',
    },
    notification: {
      invoiceSent: 'The invoice has been successfully sent.',
    },
    table: {
      sum: 'Sum',
      tip: 'Trinkgeld',
      status: 'Status',
      hasRefunds: 'Refunds',
      codes: 'Codes',
      method: 'Payment Method',
      createdAt: 'Date',
      id: 'Id',
      merchantReference: 'Merchant Reference',
      checkoutId: 'PSP-Reference',
      subMethod: 'Sub Method',
      orderedArticles: 'Ordered Articles',
      checkoutOrderedArticles: 'Checkout Ordered Articles',
    },
    form: {
      quantity: 'Quantity',
      email: 'E-Mail',
    },
  },
  option: {
    index: 'Manage Options',
    create: 'Create a new Option',
    edit: 'Edit Option',
    add: 'Add Option',
    copy: 'Copy Option',
    unlinkedOptions: 'Options not attached to articles',
    empty:
      "It looks like you haven't added any options yet. Create your first option group to make even better and customizable articles.",
    overview: 'Overview',
    tabs: {
      general: 'General',
      articles: 'Articles',
      features: 'Features',
      availableHours: 'Available Hours',
      compound: {
        features: 'Features',
        new: 'New',
        special: 'Special',
        topSelling: 'Top seller',
      },
    },
    articles: {
      table: {
        name: 'Name',
        description: 'Description',
        price: 'Price',
        sortOrder: 'Sort',
        internalNote: 'Internal Note',
        internalName: 'Internal Name',
        assets: 'Images',
        active: 'Active',
        visible: 'Visible',
        number: 'Number',
      },
      addTitle: 'Add article',
      editTitle: 'Edit article',
    },
    table: {
      name: 'Name',
      description: 'Description',
      requiredAmount: 'Required Amount',
      limit: 'Limit',
      hasMultiple: 'Has Multiple',
      sortOrder: 'Sort',
      visible: 'Visible',
      article: 'Article',
    },
    form: {
      name: 'Name',
      description: 'Description',
      shortDescription: 'Short Description',
      image: 'Image',
      externalId: 'External ID',
      limit: 'Limit',
      active: 'Active',
      visible: 'Visible',
      virtual: 'Virtual',
      sort: 'Sort',
      printerSort: 'Printer Sort',
      requiredAmount: 'Required Amount',
      hasMultiple: 'Multiple',
      displayIdentifiers: 'Display Identifiers',
      displayMode: 'Display Mode',
      displayModeSot: 'Display Mode SOT',
      displayModeMobile: 'Display Mode Mobile',
      tags: 'Tags',
      printGroups: 'Print Groups',
    },
    deleteHeader: 'Delete Options',
    deleteInfo: 'Are you sure you want to delete these options? This action cannot be undone.',
    deleteSelected: 'Delete Selected',
  },
  category: {
    index: 'Manage Categories',
    create: 'Create a new Category',
    edit: 'Edit Category',
    add: 'Add Category',
    overview: 'Overview',
    availableHours: 'Available Hours',
    table: {
      name: 'Name',
      sort: 'Sort',
      mainCategory: 'Main Category',
      visible: 'Visible',
    },
    form: {
      name: 'Name',
      description: 'Description',
      mainCategory: 'Main Category',
      sort: 'Sort',
      displayMode: 'Display Mode',
      mainRecommendations: 'Main Recommendations',
      displayIdentifiers: 'Display Identifiers',
      visible: 'Visible',
      image: 'Image',
      icon: 'Icon',
    },
    tabs: {
      features: 'Features',
      new: 'New',
      special: 'Special',
      topSelling: 'Top seller',
    },
  },
  subscriptionCategories: {
    index: 'Manage Subscription Category',
    create: 'Create a new Subscription Category',
    edit: 'Edit Subscription Category',
    add: 'Add Subscription Category',
    overview: 'Overview',
    table: {
      name: 'Name',
    },
    form: {
      name: 'Name',
      description: 'Description',
      image: 'Image',
      subscriptions: 'Subscriptions',
      venues: 'Venues',
      canCombine: 'Combine',
      isActive: 'Active',
    },
  },
  subscription: {
    index: 'Manage Subscription',
    create: 'Create a new Subscription',
    edit: 'Edit Subscription',
    add: 'Add Subscription',
    overview: 'Overview',
    table: {
      name: 'Name',
    },
    form: {
      name: 'Name',
      description: 'Description',
      image: 'Image',
      useMasterFoodcard: 'Use Master Foodcard',
      maxPricePerOrder: 'Max Price Per Order',
      maxPricePerArticle: 'Max Price Per Article',
      maxArticlesPerOrder: 'Max Articles Per Order',
      maxOrdersPerDay: 'Max Orders Per Day',
      minimumOrderOffset: 'Minimum Order Offset',
      isActive: 'Active',
      automaticallyRenew: 'Automatically Renew',
      tax: 'Tax',
      articles: 'Articles',
      venues: 'Venues',
      linkedCustomerGroup: 'Linked Customer Group',
      price: 'Price',
      factor: 'Factor',
      unit: 'Unit',
      default: 'Default',
    },
  },
  membership: {
    index: 'Manage Membership',
    create: 'Create a new Membership',
    edit: 'Edit Membership',
    add: 'Add Membership',
    overview: 'Overview',
    table: {
      name: 'Name',
    },
    form: {
      name: 'Name',
      description: 'Description',
      image: 'Image',
      multiplier: 'Multiplier',
      neededPoints: 'Needed Points',
      piggyId: 'Piggy Id',
      customerGroup: 'Customer Group',
    },
    tier: {
      membershiptier1: 'membershiptier1',
      membershiptier2: 'membershiptier2',
      membershiptier3: 'membershiptier3',
      membershiptier4: 'membershiptier4',
      membershiptier5: 'membershiptier5',
    },
  },
  table: {
    index: 'Manage Tables',
    create: 'Create a new Table',
    exportQrs: 'Export QR-Codes',
    assignLightspeedWaiter: 'Assign Lightspeed waiter',
    toggleTablesByRange: 'Toggle Tables by Range',
    toggleTablesByTag: 'Toggle Tables by Tag',
    edit: 'Edit Table',
    add: 'Add Table',
    overview: 'Overview',
    table: {
      number: 'Number',
      description: 'Description',
      active: 'Active',
      tags: 'Tags',
      qr: 'QR-Code',
      sanifairDeviceId: 'Sanifair Device-ID',
    },
    form: {
      number: 'Number',
      description: 'Description',
      sanifairDeviceId: 'Sanifair Device-ID',
      lightspeedWaiterId: 'Lightspeed-Waiter',
      simphonyRvcRef: 'Simphony RVC Reference',
      mollieTerminalId: 'Mollie terminal',
      pendingCashPaymentEnabled: 'Activate open Cash payments',
      openOrdersEnabled: 'Activate open orders',
      viewStaff: 'View Staff',
      select: 'Select',
      isActive: 'Active',
      start: 'Start',
      end: 'End',
      tag: 'Tag',
    },
    notification: {
      mollieTerminalsError: 'Could not load the Mollie terminals.',
      assignLightspeedWaiterSuccess: 'Lightspeed waiter was successfully assigned to the selected tables.',
      assignLightspeedWaiterError: 'An error occurred while assigning Lightspeed waiter to the selected tables.',
      massActiveSuccess: 'Tables were successfully updated.',
      massActiveError: 'An error occurred while updating the tables.',
    },
  },
  venue: {
    index: 'Manage Venues',
    create: 'Create a new Venue',
    copyFoodcard: 'Copy foodcard',
    editMasterId: 'Edit Master-ID',
    copyArticles: 'Copy articles',
    importHellotess: 'Import foodcard from Hellotess',
    importGastrofix: 'Import foodcard from Gastrofix',
    importDeliverect: 'Import foodcard from Deliverect',
    importSimphony: 'Import foodcard from Simphony',
    generalImport: 'General Foodcard Import',
    panic: 'Panic',
    ppConnected: 'PayPal Account Status',
    ppConnectedSuccess: 'PayPal account successfully connected.',
    ppConnectedError: 'PayPal account is not connected or failed.',
    lightspeedAuthorize: 'Authorize Lightspeed',
    lightspeedAuthorized: 'Lightspeed successfully authorized',
    lightspeedNotAuthorized: 'Lightspeed is not authorized',
    generateSlugAuto: 'Generate slug automatically',
    standardSlots: 'Standard Slots',
    terminalSlots: 'Terminal Slots',
    preorderSlots: 'Preorder Slots',
    createSimple: 'Create a new Venue',
    overview: 'Overview',
    add: 'Add Venue',
    sync: 'Sync Venue',
    tooltipCannotSync: 'Sync is already in progress. Please wait or contact an admin',
    liftSyncLock: 'Lift sync lock',
    refresh: 'Refresh',
    copy: 'Copy venue',
    copyVenueOnly: 'Copy venue only',
    deleteFoodcard: 'Delete Foodcard',
    copyConfirm: 'Are you sure you want to create a duplicate of venue?',
    copySuccess: 'Venue was copied',
    archive: 'Archive',
    testOrder: 'Send Test Order',
    registerPayPal: 'Connect PayPal Account',
    checkPayPalOnboarding: 'Check PayPal Account Status',
    deliveryFees: 'Delivery Fees',
    deliveryFeesRadius: 'Delivery Fees by Radius',
    deliveryFeesPostalCode: 'Delivery Fees by Postal Code',
    deliveryFeesAreas: 'Delivery Fees by Areas',
    edit: 'Edit Venue',
    parkCollect: 'Park & Collect',
    migrate: 'Migrate Venue',
    stations: 'Stations',
    migration: 'Migration',
    eodReport: 'EOD report',
    customerSupportMail: 'Customer support',
    generateWebAppSlug: 'Generate Web App Slug',
    panicInfo: "Information: Panic for the Venue {venue} is activated until {panicEndAt} o'clock. {reason}.",
    snoozing: 'Snoozing Options',
    offsetReset: 'Offset Reset Time',
    milesAndMore: 'Miles & More',
    kost: 'KOST',
    ncr: 'NCR',
    revel: 'Revel',
    fullcircle: 'fullcircle POS',
    arcavis: 'Arcavis',
    orderbird: 'Orderbird',
    erpVoucher: 'ERP Voucher',
    tips: 'Tips',
    notification: {
      testOrderSuccess: 'The test order was successful.',
      testOrderError:
        'The test order failed. Please check your settings or if you still have issues contact an administrator.',
      sendInvoiceSuccess: 'Invoice was successfully sent.',
      createCreditNoteSuccess: 'Credit note was successfully created.',
      registerPayPalError: 'Could not authorise paypal.',
      connectMollieSuccess: 'Mollie was connected successfully.',
      connectMollieError: 'Could not connect Mollie.',
      disconnectMollieSuccess: 'Mollie was disconnected.',
      disconnectMollieError: 'Could not disconnect Mollie.',
      checkPayPalOnboardingError: 'Could not authorise check paypay onboarding status.',
      checkPayPalOnboardingSuccess: 'Please refresh page, to see changes.',
      sendInvoiceError: 'Sending invoice failed.',
      createCreditNoteError: 'Creating credit note failed.',
      copyOptionSuccess: 'Option was copied',
      copyOptionError: 'Copy option failed. Please check the logs.',
      authorizePayPal: 'To authorize, please fill in the fields Merchant ID and Email in PayPal Credentials and save.',
      copyRunning: 'Venue copying started and is in progress.',
      copyError: 'Copy venue failed. Please check the logs.',
      webAppSlug:
        'Are you sure you want to generate the Web App Slug field? In this case it will be done for all venue.',
      masterId: 'Master-ID',
      deleteSuccess: 'Foodcard successfully deleted!',
      refreshSuccess: 'Venue refresh completed successfully.',
      refreshError: 'An error occurred while refreshing the venue.',
      sepa: {
        createSuccess: 'New SEPA Mandate Registration Link was created successfully',
        createError: 'Could not create new SEPA Mandate Registration Link',
        paySuccess: 'New SEPA Payment was created successfully',
        payError: 'Could not create new SEPA Payment',
      },
    },
    filter: {
      publishedStatus: 'Published Status',
      published: 'Published',
      unpublished: 'Not Published',
      verifiedStatus: 'Verified Status',
      syncStatus: 'Sync Status',
      idle: 'Not Synchronizing',
      sync: 'Synchronizing',
      verified: 'Verified',
      customerGroup: 'Customer Group',
      unverified: 'Not Verified',
      deletedAt: 'View Archived',
      isServiceActivatedStatus: 'Service Activated Status',
      deliveryEnabledStatus: 'Delivery Enabled Status',
      panicModeStatus: 'Panic Status',
      activated: 'Activated',
      notActivated: 'Not Activated',
      enabled: 'Enabled',
      notEnabled: 'Not Enabled',
      panicActive: 'Ongoing',
      panicInactive: 'Inactive',
    },
    station: {
      placeholder: 'Type station name',
      deleteStation: 'Are you sure you want to delete the station?',
      addStation: '+ Add station',
    },
    confirmation: {
      verify: {
        title: 'Venue Confirmation',
        text: 'By clicking the button below, you agree that all articles, prices and venue settings are correct. Furthermore you have uploaded tos, privacy and the disclaimer. For any incorrect settings, you are liable for them.',
        action: 'Verify Venue',
      },
      publish: {
        title: 'Publish Confirmation',
        text: 'By clicking the button below, you agree that all articles, prices and venue settings are correct. For any incorrect settings, you are liable for them.',
        action: 'Publish Venue',
      },
      deleteFoodcard: {
        title: 'Are you sure you want to delete the entire foodcard?',
        text: 'You are deleting all categories, articles, option groups, option articles, and tags with this action.<br/><br/>This action cannot be undone.',
      },
    },
    verify: 'Verify',
    publish: 'Publish',
    credentials: 'Credentials',
    payment: 'Payment',
    order: 'Order',
    preorder: 'Preorder',
    slotting: 'Slot Settings',
    documents: 'Documents',
    invoices: {
      createCreditNote: 'Create Credit Note',
      createCreditNoteNet: 'Create Credit Note (Net Value)',
      send: 'Send Invoice',
      transactions: 'Transactions',
      balance: 'Balance',
      type: 'Invoice Type',
      refOrNote: 'Invoice Ref / Note',
      createdAt: 'Created At',
      amount: 'Amount',
      setupFee99: 'Setup Fee (99€)',
      setupFee49: 'Setup Fee (49€)',
      premiumPrinterPackage: 'Premium Printer Package',
      printerTablet: 'Tablet with integrated printer (319,00 + 8,00 €)',
      printerTablet200: 'Tablet with integrated printer (200€ + 8€)',
      printerTablet230: 'Tablet with integrated printer (230€ + 8€)',
      provision: 'Provision',
      creditNoteNet: 'Credit Note (Net Value)',
      status: 'Status',
    },
    productCombos: {
      addCombo: 'Add Combo',
      addArticle: 'Add Article',
      addColumn: 'Add Column',
      deleteColumn: 'Delete Column',
      result: 'Select result article',
      column: 'Select article',
    },
    ci: 'Checkout Integration',
    cip: 'Checkout Integration Properties',
    general: 'General',
    details: 'Details',
    contact: 'Contact',
    whiteLabel: 'whiteLabel',
    invoiceReceiver: 'Mailing Address',
    address: 'Address',
    settings: 'Settings',
    sizeSettings: 'Size Settings',
    orderOffsets: 'Order Offsets',
    preorderOffsets: 'Preorder Offsets',
    fireTimeOffsets: 'Firetime Offsets',
    uberDelivery: 'Uber Delivery',
    miscellaneous: 'Miscellaneous',
    preorderPayment: 'Preorder Payment',
    deliveryPayment: 'Preorder Delivery Payment',
    sepaCredentials: 'SEPA Credentials',
    ccCredentials: 'CreditCard Credentials',
    ppCredentials: 'PayPal Credentials',
    sbCredentials: 'SofortBanking Credentials',
    apCredentials: 'ApplePay Credentials',
    gpCredentials: 'GooglePay Credentials',
    walleeCredentials: 'Wallee Credentials',
    worldlineCredentials: 'Worldline Credentials',
    datatransCredentials: 'DataTrans Credentials',
    adyenCredentials: 'Adyen Credentials',
    walleePaymentConfs: 'Wallee Payment',
    neptingCredentials: 'Nepting Credentials',
    eServiceCredentials: 'eService Credentials',
    mollieCredentials: 'Mollie Credentials',
    connectMollie: 'Connect Mollie account',
    disconnectMollie: 'Disconnect Mollie account',
    iCouponCredentials: 'iCoupon Credentials',
    openingHours: 'Opening Hours',
    specialOpeningHours: 'Special Opening Hours',
    deliveryHours: 'Delivery Hours',
    specialDeliveryHours: 'Special Delivery Hours',
    salesforce: 'Salesforce',
    salesforcePromotions: 'Salesforce Promotions',
    sanifair: 'Sanifair',
    delfi: 'Delfi',
    loyalty: 'Loyalty',
    loyaltyManagedGifts: {
      title: 'Como managed gifts',
      venueGifts: 'Venue gifts',
      metadata: 'Gift metadata',
      venue: 'Venue',
      name: 'Name',
      description: 'Description',
      type: 'Gift type',
      status: 'Status',
      requiredPoints: 'Required points',
      templateKey: 'Template key',
      giftId: 'Gift ID',
      imageThumb: 'Image thumbnail URL',
      imageMedium: 'Image medium URL',
      imageLarge: 'Image large URL',
      imageOriginal: 'Image original URL',
      image: 'Gift image',
      create: 'Create managed gift',
      deleteQuestion: 'Delete this gift metadata? The gift will fall back to Como text.',
      giftTypes: { reward: 'Reward', point_shop_gift: 'Point shop gift' },
      statuses: { active: 'Active', inactive: 'Inactive' },
    },
    boardingPass: 'Boarding Pass',
    datev: 'Datev',
    storeLink: 'Store link',
    viewCounters: 'View Counters',
    voucherify: 'Voucherify',
    grubtech: 'GrubTech',
    finances: 'Finances',
    nutrition: 'Nutrition',
    panicModeHistory: {
      startAt: 'Start At',
      endAt: 'End At',
      reason: 'Reason',
    },
    locTypes: {
      bar: 'Bar',
      club: 'Club',
      restaurant: 'Restaurant',
      db: 'Deutsche Bahn',
      cinema: 'Cinema',
      other: 'Other',
    },
    tabs: {
      general: 'General',
      payment: 'Payment',
      terminal: 'Terminal',
      preorder: 'Preorder',
      ci: 'Checkout Integration',
      orderOffsets: 'Order Offsets',
      order: 'Order',
      slotting: 'Slotting',
      cateringHours: 'Catering Hours',
      documents: 'Documents',
      openingHours: 'Opening Hours',
      productCombos: 'Product Combos',
      deliveryHours: 'Delivery Hours',
      deliveryProviders: 'Delivery Providers',
      externalDeliveryService: 'External Delivery Service',
      orderProviders: 'Order Providers',
      invoices: 'Invoices',
      sanifair: 'Sanifair',
      salesforce: 'Salesforce',
      delfi: 'Delfi',
      loyalty: 'Loyalty',
      boardingPass: 'Boarding Pass',
      datev: 'Datev',
      milesAndMore: 'Miles & More',
      erpVoucher: 'ERP Voucher',
      tips: 'Tips',
      voucherify: 'Voucherify',
      grubtech: 'GrubTech',
      finances: 'Finances',
      nutrition: 'Nutrition',
    },
    table: {
      name: 'Name',
      shortId: 'Short-ID',
      sort: 'Sort',
      email: 'E-Mail',
      street: 'Street',
      number: 'Number',
      city: 'City',
      legalForm: 'Legal Form',
      locType: 'Type',
      vatNumber: 'VAT-ID',
      vatNumberGermany: 'German Tax Number',
      isServiceActivated: 'Service Activated',
      deliveryEnabled: 'Delivery Enabled',
      customerGroup: 'Customer Group',
      checkoutIntegration: 'Checkout Integration',
      piggyLoyaltyEnabled: 'Loyalty',
      isPublished: 'Published',
      webAppSlug: 'Web App Slug',
      masterId: 'Master-ID',
      externalOrderProviderStatus: 'Store Status (Wolt/Uber Eats)',
      preorderTakeAway: 'Preorder Take Away',
      panicModeHistory: 'Panic History',
      cases: 'Cases',
    },
    form: {
      secondaryCodeEnabled: 'Secondary Code Enabled',
      standardOrderOffsets: 'Standard Order Offsets',
      terminalInsideOffsets: 'Terminal Inside Offsets',
      terminalTakeAwayOffsets: 'Terminal Take Away Offsets',
      preorderInsideOffsets: 'Preorder Inside Offsets',
      preorderTakeAwayOffsets: 'Preorder Take Away Offsets',
      preorderDeliveryOffsets: 'Preorder Delivery Offsets',
      cateringTakeAway: 'Allow Catering Take Away',
      cateringDelivery: 'Allow Catering Delivery',
      cateringTakeAwayHours: 'Catering Take Away Hours',
      cateringDeliveryHours: 'Catering Delivery Hours',
      cateringDeliveryOffsets: 'Catering Delivery Offsets',
      cateringTakeAwayOffsets: 'Catering Take Away Offsets',
      couponsEnabled: 'Couponing',
      cateringSlots: 'Catering Slots',
      parkCollectionLocationText: 'Location Text',
      venue: 'Venue',
      masterId: 'Master-ID',
      sort: 'Sort',
      sourceVenue: 'Source-Venue',
      targetVenue: 'Target-Venue',
      sendEodReport: 'Send EOD report to emails',
      sendEodReportEmails: 'List of emails to send reports to',
      source: 'Source',
      image: 'Image',
      masterType: 'Order Type',
      uberCustomerId: 'Uber Customer Id',
      uberDeliveryEnabled: 'Uber Delivery Enabled',
      uberBatchSize: 'Batch Size',
      externalDeliveryService: {
        name: 'Name',
        link: 'Link',
        icon: 'Icon',
      },
      name: 'Name',
      newName: 'New Name',
      asSlave: 'Create the venue as slave of the selected venue',
      sapNumber: 'SAP Number',
      externalLocationId: 'External Location Id',
      loginRequired: 'Login Requirement',
      restaurantToken: 'Smoothr Restaurant Token',
      standardSlot: 'Max. Standard Orders per interval',
      takeAwaySlot: 'Max. TakeAway Orders per interval',
      calculateDays: 'Count of days to calculate slots',
      insideSlot: 'Max. Inside Orders per interval',
      deliverySlot: 'Max. Delivery Orders per interval',
      properties: 'Properties',
      syncType: 'Sync Type',
      fullName: 'Company Name',
      currency: 'Currency',
      deliveryPostalCodes: 'Delivery Postal Codes',
      deliveryPostalCodesHint: 'Please insert a postal code with a correlating city (e.g. 50679 Cologne)',
      country: 'Country',
      locType: 'Location Type',
      deliveryFee: 'Delivery fee in {currency} (if not further specified)',
      deliveryByRadius: 'Use Delivery Radius (Otherwise by Postal Codes)',
      deliveryByAreas: 'Use Delivery Areas (Otherwise by Postal Codes)',
      provisionRate: 'Provision Rate',
      bcsig: 'BCSIG',
      supplier: 'Supplier',
      webAppUrl: 'WebApp Url',
      panicEndAt: 'Panic (if active, preorders are not possible)',
      provisionFixedRate: 'Fixed Provision Rate',
      readableId: 'Short ID',
      migrationType: 'Migration Type',
      deliveryRadius: 'Delivery Radius',
      deliveryRadiusMax: 'Delivery Radius (max)',
      isPublished: 'Published',
      venues: 'Venues',
      deliveryHours: 'Delivery Hours',
      sanifair: 'Sanifair Settings',
      active: 'Active',
      virtualOrders: 'Allow Virtual Orders',
      stock: 'Stock',
      movDelivery: 'Minimum Order Value -- Delivery (EUR)',
      checkoutIntegration: 'Checkout Integration',
      printerIntegration: 'Printer Integration',
      readyOffset: 'Preparation Offset',
      readyOffsetDelivery: 'Preparation Offset Delivery',
      interval: 'Interval Size',
      reserved: 'Reserved Orders',
      max: 'Max Orders In Interval (deprecated)',
      notPickedOffset: 'Not picked offset',
      isServiceActivated: 'Service status (if not activated, ordering is disabled)',
      isCallingSystemEnabled: 'Calling system',
      inventoryEnabled: 'Inventory Enabled',
      milesAndMoreEnabled: 'Miles & More Enabled',
      erpVoucherEnabled: 'ERP Voucher Enabled',
      legalForm: 'Legal Form',
      email: 'E-Mail',
      orderEmail: 'Order E-Mail',
      storeEmail: 'Store E-Mail',
      web: 'Website',
      standardOrders: 'Allow Standard Orders',
      preorderTakeAway: 'Allow Preorder Take Away',
      preorderParkCollect: 'Allow Park & Collect',
      preorderFoodspot: 'Allow Foodspot',
      preorderIn: 'Allow Preorder In House',
      preorderDelivery: 'Allow Delivery',
      autoAccept: 'Auto Accept in',
      autoAcceptTerminal: 'Auto Accept Terminal Order in',
      checkoutIn: 'Checkout In',
      printIn: 'Print In',
      autoReset: 'Auto Reset In',
      orderTimeout: 'Order Timeout',
      orderTimeoutEnabled: 'Activate Order Timeout',
      phone: 'Phone',
      fax: 'Fax',
      city: 'City',
      area: 'Nearest City',
      street: 'Street',
      streetAddress: 'Street Address',
      number: 'Number',
      company: 'Company',
      postalCode: 'Postal Code',
      federalState: 'Federal State',
      deliveryAddress: 'Delivery Address',
      orderPrinterTabletPackageInfo:
        'Order a tablet with integrated printer for {price}€. Without a printer you only receive new orders via email.',
      orderPremiumPackage: 'Order Printer',
      timezone: 'Timezone',
      googlePlacesId: 'Google Places ID',
      customerGroup: 'Customer Group',
      sendProvisionReportPeriod: 'Send Provision Report',
      lastInvoiceNumber: 'Last invoice number',
      sendProvisionReportPeriodNonInvoiceable: 'Send Provision Report (without invoice number)',
      vatNumber: 'VAT-ID',
      vatNumberQuestion: 'Use USt-IdNr.?',
      vatNumberGermany: 'German Tax Number (e.g. 12/345/67890)',
      vatNumberGermanyQuestion: 'No USt-IdNr.?',
      mov: 'MOV',
      from: 'From',
      fee: 'Fee',
      deliveryArea: 'Delivery Area',
      secureCode: 'Secure Code',
      selfCertification: 'Self Certification',
      reviewHyperlink: 'Review hyperlink',
      pdfUpload: 'Upload PDF-File',
      kmlUpload: 'Upload KML-File',
      insertLink: 'Insert Link',
      nutritionTable: 'Nutrition Table',
      nutritionInfo: 'Nutrition Info',
      gpsManualInput: 'Manual Input (GPS Coordinates)',
      gpsCorrect: 'GPS Coordinates ok?',
      latitude: 'Latitude',
      longitude: 'Longitude',
      adyenEnabled: 'Adyen Enabled',
      adyenPaypalEnabled: 'Adyen PayPal Enabled',
      merchantAccount: 'Merchant Account',
      urlPrefix: 'URL Prefix',
      clientKey: 'Client Key',
      property: 'Property',
      paymentEnabled: 'Payment Enabled',
      sepaEnabled: 'SEPA Enabled',
      sbEnabled: 'SofortBanking Enabled',
      gpEnabled: 'GooglePay Enabled',
      apEnabled: 'ApplePay Enabled',
      ppEnabled: 'PayPal Enabled',
      vrPaymentEnabled: 'VR Enabled',
      rekaEnabled: 'Reka Enabled',
      twintEnabled: 'Twint Enabled',
      walleeEnabled: 'Wallee Enabled',
      tacEnabled: 'Tac Enabled',
      comoLoyaltyEnabled: 'Como Loyalty Enabled',
      tipRefundEnabled: 'Tip Refund Enabled',
      alipayEnabled: 'Alipay Enabled',
      wcEnabled: 'WeChat Pay Enabled',
      bcEnabled: 'Boncard Enabled',
      lchEnabled: 'Luncheck Enabled',
      cwlEnabled: 'Worldline Enabled',
      ccvEnabled: 'CCV Enabled',
      zeroPaymentEnabled: 'Zero Payment Enabled',
      woltPaymentEnabled: 'Wolt Payment Enabled',
      uberEatsPaymentEnabled: 'Uber-Eats-Payment Enabled',
      jetPaymentEnabled: 'JET-Payment Enabled',
      deliverooPaymentEnabled: 'Deliveroo-Payment Enabled',
      kostCardPaymentEnabled: 'KOST-Card-Payment Enabled',
      ctCreditCardPaymentEnabled: 'Computop CreditCard Enabled',
      bankTransferPaymentEnabled: 'Bank Transfer Enabled',
      dataTransEnabled: 'Datatrans Enabled',
      piggyGiftCardEnabled: 'Piggy GiftCard Enabled',
      piggyPrepaidBalanceEnabled: 'Piggy Prepaid Balance Enabled',
      comoGiftCardEnabled: 'Como GiftCard Enabled',
      sapCCOEnabled: 'SAP CCO Enabled',
      worldlineEnabled: 'Worldline Enabled',
      wlApplePayEnabled: 'Worldline Apple Pay Enabled',
      wlApplePayMobileEnabled: 'Worldline Apple Pay Mobile Enabled',
      wlGooglePayEnabled: 'Worldline Google Pay Enabled',
      wlGooglePayMobileEnabled: 'Worldline Google Pay Mobile Enabled',
      wlCardEnabled: 'Worldline Card Enabled',
      wlCardMobileEnabled: 'Worldline Card Mobile Enabled',
      pfEnabled: 'PostFinance E-Finance Enabled',
      pfcEnabled: 'PostFinance Card Enabled',
      ppV2Enabled: 'PayPal V2 Enabled',
      ppFullIntegrationEnabled: 'PayPal Full Integration Enabled',
      ccEnabled: 'CreditCard Enabled',
      posEnabled: 'POS Enabled',
      cashEnabled: 'Cash Enabled',
      neptingEnabled: 'Nepting Enabled',
      eServiceEnabled: 'eService Enabled',
      mollieEnabled: 'Mollie Enabled',
      mollieTestmode: 'Mollie test mode (non-production only)',
      iCouponEnabled: 'iCoupon Enabled',
      vippsEnabled: 'Vipps Enabled',
      swishEnabled: 'Swish Enabled',
      mobilePayEnabled: 'MobilePay Enabled',
      dankortEnabled: 'Dankort Enabled',
      maxxvendEnabled: 'MAXXvend Enabled',
      amexEnabled: 'Amex Enabled',
      secretKey: 'Secret Key',
      merchantName: 'Merchant Name',
      creditorId: 'Creditor Id',
      merchantId: 'Merchant Id',
      merchantIdPP: 'Merchant Id',
      serviceProviderRef: 'Service Provider Ref',
      outletRef: 'Outlet Ref',
      locationRef: 'Location Ref',
      userId: 'User Id',
      spaceId: 'Space Id',
      userKey: 'User Key',
      reka: 'Reka',
      twint: 'Twint',
      boncard: 'Boncard',
      luncheck: 'Luncheck',
      postfinance: 'Postfinance',
      postfinanceCard: 'Postfinance Card',
      wechat: 'Wechat',
      alipay: 'Alipay',
      worldline: 'Worldline',
      ppEmail: 'Account E-Mail',
      ppEmailConfirmed: 'PayPal Email is Confirmed',
      ppEmailNotConfirmed: 'PayPal Email is not Confirmed',
      ppPaymentsReceivable: 'PayPal Payments are receivable',
      ppPaymentsNotReceivable: 'PayPal Payments are not receivable',
      vrAccessToken: 'VR-Payment Access Token',
      receiptLogo: 'Receipt Logo',
      articleSpanCount: 'Article Span Count',
      categorySpanCount: 'Category Span Count',
      fullWidthCategories: 'Categories On full Width',
      showInactiveArticles: 'Show Interactive Articles',
      askForTableNumber: 'Ask For Table Number',
      foodAndBeveragesSeparated: 'Food And Beverages Separated',
      toolbarTitleHidden: 'Toolbar Title Hidden',
      displayCirclePickerDescription: 'Display Circle Picker Description',
      toolbarCategoryListVisible: 'Toolbar Category List Visible',
      toolbarSidesVisible: 'Toolbar Sides Visible',
      multiLanguage: 'Multi language',
      printQr: 'Print QR',
      firstOrderOffset: 'Earliest Order Offset',
      orderOffset: 'Minimum Order Offset',
      lastOrderOffset: 'Latest Order Offset',
      dailyUnsnoozeTime: 'Article Offset',
      offsetResetEnabled: 'Reset preparation time enabled',
      offsetResetTime: 'Time',
      pickupBoxKey: 'Pickup Box Key',
      pickupBoxDeviceId: 'Pickup Box Device Id',
      pickupBoxAppId: 'Pickup Box App Id',
      pickupBoxCredentials: 'Pickup Box Credentials',
      id: 'Id',
      apiGateway: 'Api Gateway',
      apiKey: 'Api Key',
      apiSecret: 'Api Secret',
      apiUrl: 'Api Url',
      profileId: 'Profile Id',
      establishmentId: 'Establishment Id',
      dataTransMerchantId: 'DataTrans Merchant Id',
      dataTransMerchantPassword: 'DataTrans Merchant Password',
      dataTransMerchantWebhookKey: 'DataTrans Merchant Webhook Key',
      pspId: 'Psp Id',
      host: 'Host',
      sdCredentials: 'Sd Credentials',
      orderOffsetHint:
        'Please insert how many minutes after opening shall pass before accepting the first order, 60 = 1 hour',
      lastOrderOffsetHint:
        'Bitte geben Sie hier an, wie vielen Minuten vor Ladenschließung eine Bestellung eingehen darf, 60 = 1 Std',

      preorderOffset: 'Minimum Preorder Offset',
      preorderOffsetHint:
        'Please insert how many minutes after opening shall pass before accepting the first order, 60 = 1 hour',
      firstPreorderOffset: 'Earliest Preorder Offset',
      lastPreorderOffset: 'Latest Preorder Offset',
      lastPreorderOffsetHint:
        'Bitte geben Sie hier an, wie vielen Minuten vor Ladenschließung eine Bestellung eingehen darf, 60 = 1 Std',
      phoneHint: 'e.g. +4912345678901',
      autoDeclineTime: 'Cancel time',
      uploadedFile: 'Uploaded file',
      terms: 'Terms and Conditions',
      imprint: 'Imprint',
      privacy: 'Privacy',
      accessibility: 'Accessibility statement',
      other: 'Other document',
      registerCourt: 'Register Court',
      registerNumber: 'Register Number',
      chiefExecutives: 'Chief Executive(s)',
      sepaMandateRef: 'SEPA Mandate Reference',
      sepaMandateRegistrationLink: 'SEPA Mandate Registration Link',
      sepaMandateRegistrationError: 'SEPA Mandate Registration Error',
      piggyLoyaltyEnabled: 'Piggy Loyalty Enabled',
      webAppSlug: 'Web App Slug',
      takeAway: 'Take Away',
      delivery: 'Delivery',
      foodspot: 'Foodspot',
      terminalUsername: 'Terminal Username',
      terminalPassword: 'Terminal Password',
      mobileUsername: 'Mobile Username',
      mobilePassword: 'Mobile Password',
      deliveryProviders: {
        orderLord: 'OrderLord',
        rushHour: 'Rush Hour',
        woltDrive: 'Wolt Drive',
        ultraDispo: 'Ultra Dispo',
        orderLordEnabled: 'Enabled',
        orderLordActive: 'OrderLord Available (set by administrator)',
        orderLordToken: 'OrderLord API Token',
        orderLordPassword: 'OrderLord API Password',
        rushhourIntegration: 'Rush Hour Integration Enabled',
        rushhourToken: 'Rush Hour Token',
        woltdriveToken: 'Wolt Drive Token',
        woltdriveMerchantId: 'Wolt Drive ID',
        smoothrDispatchEnabled: 'Smoothr Dispatch',
        customerId: 'Customer Id',
        clientId: 'Client Id',
        clientSecret: 'Client Secret',
        batchSize: 'Batch Size',
        deliveryOffsetCalculationMode: 'Delivery Offset Calculation Mode',
        deliveryOffsetCalculationModeLegacy: 'Legacy',
        deliveryOffsetCalculationModeVersionJuly2026: 'Version July 2026',
        refundEmails: 'Refund emails',
        enabled: 'Enabled',
        merchantUsername: 'Merchant Username',
        merchantPassword: 'Merchant Password',
        deliverableOrderTypes: 'Deliverable Order Types',
        pinVerificationEnabled: 'Pin-Verification Enabled',
        pinVerificationMinimumAmount: 'Min. Order Total Price Pin-Verification',
        dishbee: 'Dishbee',
        kurierzentrale: 'Kurierzentrale',
        botToken: 'Bot-Token',
        channelId: 'Channel-ID',
        username: 'Username',
        password: 'Password',
        partnerId: 'Partner ID',
        locationReferenceId: 'Location Reference',
        averageDeliveryTime: 'Average Delivery Time',
        deliveryFailureRecipientEmails: 'Delivery failure recipient emails',
      },
      externalOrderProviders: {
        useExternalProviders: 'Use external order providers',
        generalSettings: 'General Settings',
        skipExternalOrderValidation: 'Accept order with inactive articles',
        skipExternalOrderValidationNotice:
          'When enabled, accepts orders from order-providers, even if the order contains articles, that are DEACTIVATED in smoothr.',
        sendOrdersWithInactiveArticlesToPos: 'Send the order with inactive article to the POS',
        orderDirectEnabled: 'OrderDirect Enabled',
        orderDirectImprint: 'OrderDirect Imprint',
        woltEnabled: 'Wolt Enabled',
        autoSyncTimesEnabled: 'Sync times automatically',
        enableAutoOrderReady: 'Set orders automatically in ready',
        connectWolt: 'Get onto Wolt',
        connectUberEats: 'Get onto Uber Eats',
        syncAllFoodcards: 'Sync all Foodcards',
        uberEatsEnabled: 'Uber Eats Enabled',
        jetEnabled: 'JET Enabled',
        deliverooEnabled: 'Deliveroo Enabled',
        storeId: 'Store-ID',
        siteId: 'Site-ID',
        brandId: 'Brand-ID',
        coverPhotoUrl: 'Menu Image',
        menuDescription: 'Menu Description',
        apiVersion: 'API-Version',
        venue: 'Venue-ID',
        username: 'Benutzername',
        password: 'Passwort',
        orderApiKey: 'Order-Api-Key',
        apiKey: 'Api-Key',
        syncFoodcard: 'Sync foodcard',
        syncStatus: 'Sync Venue Status',
        syncOpeningHours: 'Sync Opening hours',
        foodcardSyncStarted: 'Menu synchronization has been added to the queue and will be started soon.',
        online: 'The venue has been activated. Orders are now possible',
        offline: 'The venue has been deactivated. Orders are not possible.',
        openingHoursSynched: 'The opening hours have been synchronized.',
        preparationTime: 'Average preparation time',
        deliveryTime: 'Average delivery time',
        autoAccept: 'Automatically accept orders',
        autoAcceptByPos: 'Automatically accept (POS)',
        ocuFlowEnabled: 'OCU Flow',
        articleAvailabilitySyncEnabled: 'Sync Article Availability',
        clientId: 'Client-Id',
        clientSecret: 'Client-Secret',
        checkoutIntegrationDelayingEnabled: 'Delay checkout integration (POS)',
        autoSyncEnabled: 'Sync foodcard automatically',
        enforceDeliveryMenuHours: 'Enforce delivery menu hours',
        providerTabletEnabled: 'Provider Tablet Enabled',
        ignorePosStatusEvents: 'Ignore POS Events',
        dispatchMode: 'Delivery mode',
        articleDependencyMode: 'Article dependency mode',
        providerVenueModes: {
          provider_delivery: 'Delivery by provider',
          own_delivery: 'Lieferung durch durch das Restaurant',
        },
        articleDependencyModes: {
          ignore_article: 'Ignore main article',
          ignore_dependency_only: 'Add article, but ignore dependencies',
        },
        refreshAlert: 'Please refresh the page to see the changes',
        shouldReplaceDeposit: 'Replace deposit article',
        visible: 'Visible',
        defaultPreparationTime: 'Default Preparation Time',
        defaultPreparationTimeHint:
          'If the automatic reset is enabled, the preparation time will automatically be set to this value after a certain period of time.',
      },
      invoiceReceiver: {
        email: 'Alternative invoice receiver email address (otherwise contact email will be used)',
      },
      deliveryFeesAfterCreation: 'Delivery fees can be specified in venue settings after creation.',
      sanifairEnabled: 'Sanifair-Integration',
      sanifairBingoEnabled: 'Sanifair Bingo Active',
      sanifairLocationId: 'Sanifair-Location-Id',
      sanifairDeviceId: 'Sanifair-Device-Id',
      addExternalDelivery: 'Add external delivery service',
      deleteExternalDelivery: 'Delete',
      customerSupportMail: {
        email: 'E-Mail',
      },
      sandboxUrl: 'Sandbox Url',
      clientId: 'ClientId',
      clientSecret: 'Client Secret',
      username: 'Username',
      password: 'Password',
      recordType: 'Record Type',
      channelPc: 'Channel Pc',
      enabled: 'Enabled',
      ccvApikey: 'ccvApikey',
      comoApiKey: 'comoApiKey',
      installationId: 'Installation Id',
      locationId: 'Location Id',
      authenticationToken: 'Authentication Token',
      defaultTemplate: 'Default Template',
      delfiUrl: 'Delfi Url',
      disabledFields: 'Disabled Fields',
      disabledFieldsList: {
        allergens: 'Allergens',
        template: 'Template',
        pictograms: 'Pictograms',
        description_translations: 'Description Translations',
        disclamer_translations: 'Disclaimer Translations',
      },
      syncMenu: 'Sync Menu',
      activateForm: 'Activate The Form',
      boardingPassVerificationEnabled: 'Validate Boarding-Pass',
      paxControlScanningPositionId: 'Pax Control Scanning Position Id',
      costCenter: 'Cost center',
      ecrNumber: 'ECR Number',
      account: 'Acccount',
      offsetAccount: 'Offset account',
      actions: {
        addPaymentMapping: 'Add Payment Method Mapping',
        removePaymentMapping: 'Remove Payment Method Mapping',
        addOrderTypeMapping: 'Add Order Type Mapping',
        removeOrderTypeMapping: 'Remove Order Type Mapping',
      },
      paymentMethodMappings: 'Payment Method Mappings',
      orderTypeMappings: 'Order Type Mappings',
      checkoutIntegrationProps: {
        serviceUrl: 'Service Url',
        orgname: 'Org name',
        orgShortName: 'Org Short Name',
        locRef: 'Loc Ref',
        rvcRef: 'Rvc Ref',
        username: 'Username',
        password: 'Password',
        clientId: 'Client Id',
        authUrl: 'Auth Url',
        version: 'Version',
        checkHandling: 'Check Handling',
        defaultEmployee: 'Default Employee',
        defaultOrderType: 'Default OrderType',
        orderTypeInside: 'Order Type Inside',
        orderTypeTakeAway: 'Order Type Take Away',
        orderTypeDelivery: 'Order Type Delivery',
        orderTypeFoodspot: 'Order Type Foodspot',
        serviceChargeTip: 'Service Charge Tip',
        serviceChargeDeposit: 'Service Charge Deposit',
        serviceChargeDeliveryFee: 'Service Charge Delivery Fee',
        orderTypeInsideTerminal: 'Order Type Inside Terminal',
        orderTypeTakeAwayTerminal: 'Order Type Take Away Terminal',
        firetimeOffset: 'Firetime Offset',
        averageDeliveryTime: 'Average Delivery Time',
        useExternalId: 'Use External Id',
        autoSyncEnabled: 'Enable Visibility Autosync',
        priceAutoSyncEnabled: 'Enable Price Autosync',
        useSanifairAsTender: 'Use Sanifair As Tender',
        useTableAsEmployee: 'Use Table As Employee',
        useCodeAsOrderCode: 'Use Code As Order Code',
        useSecondaryCodeAsOrdercode: 'Use Secondary Code As Ordercode',
        retryOnApiCrash: 'Retry On Api Crash',
        skipRetryOnPosError: 'Skip Retry On POS Errors',
        useZeroCode: 'Use Zero Code',
        orderChannelRef: 'Order Channel Ref',
        orderChannelRefMapping: 'Order Channel Ref Mapping',
        addOrderChannelRefMapping: 'Add Order Channel Ref Mapping',
        firetimeEnabled: 'Firetime Enabled',
        sendOrderNotes: 'Send Order Notes',
        hideTableName: 'Hide Table Name',
        healthcheckEnabled: 'Health Check Enabled',
        multiConventional: 'Multi Conventional',
        cancelTenderType: 'Cancel Order Type',
        cashPaymentCancelTimeout: 'Cash Payment Cancel Timeout',
        useCancelTenderType: 'Use Cancel Order Type',
        excludedTenders: 'Excluded Tenders (from Multi-Conventional)',
        multiConventionalRevenueCenters: 'Multi Conventional Revenue Centers',
        multiConventionalOrderProfiles: 'Multi Conventional Order Profiles',
        sentBoardingPassEnabled: 'Sent boarding pass',
        sentRbiLoyaltyEnabled: 'Sent Rbi Loyalty Enabled',
        recalculatePayment: 'Recalculate Payment',
        replaceCashOrdersByVirtualOrders: 'Replace Cash Orders with Virtual Orders',
        deepHierarchyOnMultiConventionalOrders: 'Deep Hierarchy on Multiconventional Orders',
        priceSequence: 'Price Sequence',
        orderProfile: 'Order Profile',
        taxRate: 'Tax Rate',
        sku: 'SKU',
        value: 'Value',
        prices: 'Prices',
        zeroPaymentMapping: 'Payment Method Mapping (Zero Payment)',
        postfinanceMapping: 'Payment Method Mapping (Postfinance)',
        preparationTime: 'Average Preparation Time',
        deliveryTime: 'Average Delivery Time',
        piggyPrepaidBalance: 'Piggy Prepaid Balance',
        piggyGiftCard: 'Piggy GiftCards',
        allowManualBooking: 'Allow manual booking',
        useTerminalName: 'Use terminal name field instead of "TERMINAL"',
        sendTableNumberAsOrderNote: 'Send table number as order (Note)',
        financialApiEnabled: 'Receipts activated',
        discountArticles: 'Discount Articles',
        depositArticles: 'Deposit Articles',
        deposit: 'Deposit',
        discountAsArticlesEnabled: 'Send Discount as Article',
        revenueCenter: 'Revenue Center',
        terminalRevenueCenters: 'Terminal Revenue Centers',
        preOrderRevenueCenters: 'Preorder Revenue Centers',
        externalOrderProviderRevenueCenters: 'External Order Provider Revenue Centers',
        addTerminalRevenueCenter: 'Add Terminal Revenue Center',
        addPreOrderRevenueCenter: 'Add Preorder Revenue Center',
        addExternalOrderProviderRevenueCenter: 'Add External Order Provider Revenue Center',
        externalOrderProviderType: 'External Order Provider Type',
        cncEnabled: 'CNC Enabled',
        webhookEnabled: 'Simphony Webhooks Enabled',
        cncAuthUrl: 'CNC Authentication-URL',
        cncUsername: 'CNC Username',
        cncPassword: 'CNC Password',
        cncClientId: 'CNC Client Id',
        cncApiUrl: 'CNC API URL',
        cncHierUnit: 'CNC Hier Unit Id',
        useNotesAsOrderCodeEnabled: 'Send order notes as order code',
        default: 'Default',
        paymentMethod: 'Payment Method',
        revelType: 'Revel Type',
        fullcircleLocationId: 'fullcircle location ID',
        fullcircleRegisterId: 'fullcircle register ID (optional)',
        fullcircleRegisterRef: 'fullcircle register alias (optional)',
        fullcircleMethod: 'fullcircle payment method code',
        ncrType: 'NCR Type',
        useSimphonyPrice: 'Use Simphony Price',
        disabledFields: 'Deactivated Payload-Fields',
        stockMode: 'Stock Mode',
        nepOrganization: 'Nep Organisation',
        nepEnterpriseUnit: 'Nep Enterprise Unit',
        secretKey: 'Secret Key',
        sharedKey: 'Shared Key',
        integrationKey: 'Integration Key',
        license: 'License',
        tipPaymentMethod: 'Tip Payment Method',
        arcavisId: 'Arcavis ID',
        locationId: 'Location ID',
        environment: 'Environment',
        webhookSecret: 'Webhook Secret',
        orderbirdMethod: 'Orderbird Method',
      },
      addTip: 'Add Tip',
      removeTip: 'Remove Tip',
      addDefaultTip: 'Add Default Tip',
      tipEnabled: 'Tip Enabled',
      orderType: 'Order Type',
      subOrderTypes: 'Sub Order Types',
      subOrderType: 'Sub Order Type',
      defaultTips: 'Default Tips',
      defaultTipValue: 'Default Tip Value',
      defaultTipType: 'Default Tip Type',
      defaultTip: 'Default Tip',
      panicReason: 'Panic Reason',
      accountName: 'Account Name',
      tipTypes: {
        absolute: 'Fixed value',
        relative: 'Percentage',
        any: 'Any value',
      },
      salesforcePromotionsEnabled: 'Salesforce Promotions Enabled',
      voucherify: {
        enabled: 'Enabled',
        appId: 'App ID',
        appKey: 'App Key',
        loyaltyCampaign: 'Loyalty Campaign',
      },
      grubtech: {
        enabled: 'Enabled',
        storeId: 'Store ID',
        apiKey: 'API Key',
        partnerId: 'Partner ID',
        integrationName: 'Integration name',
      },
      finances: {
        customerNumber: 'Customer Number',
        licences: 'Licences',
        sot: 'Amount of SOT',
        sco: 'Amount of SCO',
        operator: 'Amount of Operator-Licenses',
        pickup: 'Amount of PickUp-Licenses',
        driveIn: 'Amount of DriveIn-Licenses',
        menuboard: 'Amount of Menuboard-Licenses',
        custom: 'Additional Licenses',
        hardware: 'Hardware/Devices',
        addHardware: 'Add Hardware/Device',
        removeHardware: 'Remove Hardware/Device',
        count: 'Count',
        rentStartedAt: 'Rent started at',
        rentEndedAt: 'Rent ended at',
      },
    },
    legal: {
      useTemplate: 'Use Template',
      termsHtml: '',
      imprintHtml: '',
      privacyHtml: '',
      accessibilityHtml: '',
      otherHtml: '',
    },
    infoOpeningHours: {
      openingHours: `- You can add opening hours for individual days by clicking on a day and choosing a time slot. To save the opening hours, click on the clock icon.<br />
      - By selecting multiple days a week at once, you can add the same opening hours for those days. To save the opening hours, click on the clock icon.<br />
      - You can also add multiple opening hours for one day by repeating the steps for setting individual opening hours.`,
      specialOpeningHours: `- If you want your restaurant to have special opening hours on a specific day (e.g. holidays), you can add them here. Just choose a date and add the special hours.<br />
      - If you want to close your restaurant on a specific date, you can choose the day and click the Restaurant closed checkbox. The restaurant will be closed the whole day.<br />
      - Otherwise, if you need to close your restaurant for a specific amount of time on a special date, you can choose the date and a time slot, then click the Restaurant closed checkbox. The restaurant will be closed for this specific timeslot.<br />
      - Please make sure you have added opening hours first. Otherwise, your special opening hours will not be saved.`,
    },
    infoDeliveryHours: {
      deliveryHours: `- You can add delivery hours for individual days by clicking on a day and choosing a time slot. To save the delivery hours, click on the clock icon.<br />
      - By selecting multiple days a week at once, you can add the same delivery hours for those days. To save the delivery hours, click on the clock icon.<br />
      - You can also add multiple delivery hours for one day by repeating the steps for setting individual delivery hours.`,
      specialDeliveryHours: `- If you want your restaurant to have special delivery hours on a specific day (e.g. holidays), you can add them here. Just choose a date and add the special hours.<br />
      - If you want to close your restaurant for delivery on a specific date, you can choose the day and click the Restaurant closed checkbox. The restaurant will be closed for delivery the whole day.<br />
      - Otherwise, if you need to close your restaurant for delivery for a specific amount of time on a special date, you can choose the date and a time slot, then click the Restaurant closed checkbox. The restaurant will be closed for delivery for this specific timeslot.<br />
      - Please make sure you have added delivery hours first. Otherwise, your special delivery hours will not be saved.`,
    },
  },
  analytic: {
    from: 'From',
    to: 'To',
  },
  stats: {
    index: 'Manage Statistics',
    indexAnalytics: 'Manage Analytics',
    totalNumberOfOrders: 'Number of Orders',
    avgOrdersPerDay: 'Ø Number of Orders/Day',
    avgAmount: 'Ø Order value',
    totalAmount: 'Total Sum',
    totalSoldArticles: 'Sold Articles',
    highestDaysSale: 'Highest Daily Revenue',
    totalPreCheckouts: 'Confirmed Precheckouts',
    paymentMethod: 'Payment Method',
    avgOrderDuration: 'Ø Ordertime',
    totalTimeouts: 'Number of timeouts',
    monthSales: 'Month sales',
    selectVenue: 'Select venue first',
    customerGroup: 'Customer Group',
    ui: {
      country: 'Country',
      search: 'Search',
      bestSold: 'Best sold',
      worstSold: 'Worst sold',
      ordersView: 'Orders view',
      articleView: 'Article view',
      quantity: 'Quantity',
      orders: 'Orders',
      price: 'Price',
      refresh: 'Refresh',
      debug: 'TESTING',
      prod: 'LIVE',
      customerGroup: 'CustomerGroup',
      flavor: 'Select Flavor(s)',
      status: 'Select Status(es)',
      checkoutIntegrationStatus: 'Select POS Status(es)',
      paymentMethod: 'Select Payment Method(s)',
      smoothrOnly: 'Smoothr Only',
      table: 'Select Type(s)',
      type: 'Select Table(s)',
      platforms: 'Select Platform(s)',
      label: 'Select Label',
      externalOrderProvider: 'Select Provider',
      searchId: 'Search ID',
      searchCode: 'Search Code',
      number: 'Number',
      copyOrderId: 'Copy order id',
      orderId: 'Order Id',
      note: 'Note',
      today: 'Today',
      yesterday: 'Yesterday',
      monthly: 'Monthly',
      daily: 'Daily',
      showReceipts: 'Show Receipts',
      showLogs: 'Show Logs',
      logs: 'Logs',
      more: 'more',
      deliveryFee: 'Delivery Fee',
    },
    table: {
      order: 'Order',
      paymentMethod: 'Payment Method',
      date: 'Date',
      orderDate: 'Order Date',
      orderTime: 'Order Time',
      customer: 'Customer',
      time: 'Time',
      qty: 'Quantity',
      venue: 'Venue',
      itemName: 'Items',
      allCat: 'All Categories',
      cat: 'Categories',
      type: 'Order Type',
      subType: 'Order Subtype',
      status: 'Status',
      table: 'Table',
      price: 'Price/Article',
      total: 'Total',
      name: 'Name',
      note: 'Note',
      secondaryCode: 'Secondary Code',
      dndCompanyCode: 'Company Code',
      retry: 'Retry',
      createdAt: 'Created',
      level: 'Level',
      source: 'Source',
      logs: 'Logs',
      provider: 'Provider',
      loyaltyArticles: 'Loyalty Articles',
      orderedArticles: 'Ordered Articles',
      clientMeta: 'Client Meta',
      platform: 'Platform',
      device: 'Device',
      browser: 'Browser',
      appVersion: 'App Version',
      osVersion: 'OS Version',
      externalOrderId: 'External Order Id',
      room: 'Room',
      pickupStation: 'Pickup Station',
      checkoutIntegrationStatus: 'POS Status',
      promoCode: 'Promo Code',
    },
    platforms: {
      web: 'Web',
      ios: 'iOS',
      android: 'Android',
    },
  },
  sales: {
    index: 'Product Sales',
    ui: {
      category: 'Select Category(ies)',
      item: 'Select Item(s)',
      label: 'Select Venue Label',
      dateType: 'Date Type',
      createdAt: 'Order Date',
      orderAt: 'Pickup/Delivery Date',
    },
    table: {
      name: 'Name',
      sales: 'Sales',
      total: 'Total',
      cat: 'Category',
    },
  },
  salesOverview: {
    index: 'Sales Overview',
    filter: {
      customerGroup: 'Customer group',
      flavor: 'Flavor',
    },
    table: {
      venue: 'Venue',
      webApp: 'Web App',
      terminal: 'Terminal',
      terminalTakeaway: 'Terminal Takeaway',
      terminalInside: 'Terminal Inside',
      wolt: 'Wolt',
      uberEats: 'Uber Eats',
      jet: 'Jet',
      pickup: 'Pickup',
      delivery: 'Delivery',
      total: 'Total',
      orders: 'Orders',
      amount: 'Amount',
      totalOrders: 'Total Orders',
      totalAmount: 'Total Amount',
      inside: 'Webshop Inside',
      foodspot: 'Foodspot',
      orderAtTable: 'Order at Table',
    },
  },
  billing: {
    index: 'Billing',
    billing: 'Export Billing',
    orderCsv: 'Export Orders (The Export will be sent to the email with which you are currently logged in.)',
    foodspotExport: 'Export Foodspot (The Export will be sent to the email with which you are currently logged in.)',
    paymentMethodCsv:
      'Export Orders by Payment Method (The Export will be sent to the email with which you are currently logged in.)',
    salesCsv: 'Export Sales (The Export will be sent to the email with which you are currently logged in.)',
    salesGroup: 'Export sales group (The Export will be sent to the email with which you are currently logged in.)',
    summary: 'Export Billing Summary',
    summaryVenueRequired: 'Select one venue for the invoice summary.',
    plainSummary: 'Export Billing Plain Summary',
    datev: 'Export Datev',
    articlesOverview: 'Order type',
    wallet: 'Export Wallet',
    form: {
      venue: 'Venue',
      company: 'Company',
      label: 'Venue label',
      flavor: 'Flavor',
      customerGroup: 'Customer Group',
      withoutTags: 'Don`t filter "empty" tags',
      showExpanded: 'Show expanded data',
      subscribedToMailing: 'Subscribed to newsletter',
      filterEmptyByMail: 'Filter empty by mail',
      typeExportFile: 'Type of exported file',
      requiredField: 'Please choose one of the fields',
    },
  },
  userExport: {
    index: 'User export',
    userExport: 'Export user',
    userCsv: 'Export users',
    userWithNewsletterCsv: 'Export users with newsletter',
    form: {},
  },
  activityLogExport: {
    index: 'Activity Log Export',
    activityLogCsv: 'Export logs',
    form: {
      type: 'Type',
      venue: 'Venue',
      typeExportFile: 'Type of exported file',
    },
  },
  sepa: {
    index: 'SEPA',
    title: 'SEPA settings',
    mandate: 'Mandate',
    sepaMandate: 'SEPA Mandate',
    venues: 'Venues',
    createSepa: 'Create new SEPA Mandate',
    debit: 'SEPA Debit',
    payLast: 'Pay invoices of last 30 days',
    notification: {
      cancelError: 'Error while cancelling SEPA Mandate',
      cancelWarning:
        'Are you sure to cancel this SEPA Mandate? It will be removed and can not be used for payments anymore.',
      createError: 'Could not create new SEPA Mandate Registration Link',
      createWarning:
        'Are you sure to create a new SEPA Mandate Registration Link? Existing SEPA Mandates for selected venues will be removed and can not be used for payments anymore.',
      payWarning: 'SEPA Mandate exists for this venue. Do you want to create a new SEPA Payment for this transaction?',
      payLastTransactionsWarning:
        'Are you sure to mandate payments for all invoices of the last 30 days for these venues? Afterwards single payments can be cancelled within 2 days. In this case please contact the support immediately.',
      payLastTransactionsSuccess:
        'invoices of the last 30 days paid. You will receive an email for each mandated payment. Please contact the support within 2 days, if you want to cancel one of the payments.',
    },
    form: {
      merchantId: 'Merchant Id',
      venues: 'Venues',
      merchantName: 'Merchant Name',
      payLastTransactionsAfterCreate: 'Pay open invoices of the last 30 days *',
      payLastTransactionsAfterCreateHint:
        'All open invoice amounts of the last 30 days will be charged by our system after creation of SEPA mandate. You will receive an email for each mandated payment in the next hours. Please contact the support within 2 days, if you want to cancel one of these payments.',
      sepaMandateRef: 'SEPA Mandate Reference',
      sepaMandateRegistrationLink: 'SEPA Mandate Registration Link',
      sepaMandateRegistrationError: 'SEPA Mandate Registration Error',
    },
  },
  productCombos: {
    index: 'Product combos',
    overview: 'Overview',
  },
  tips: {
    terminal: 'Terminal',
    webApp: 'WebApp',
    inside: 'Inside',
  },
  promo: {
    index: 'Manage Promo Codes',
    create: 'Create a new Promo Code',
    edit: 'Edit Promo Code',
    exportCsv: 'Export',
    exportSummary: 'Export Summary',
    exportCount: 'Export Activation Summary',
    overviewCsv: 'Export PromoCodes',
    exportTeedeliZip: 'Export Teedeli Promo Codes (*.zip)',
    exportGeneralOverview: 'Export General Overview',
    overview: 'Overview',
    add: 'Add Promo Code',
    addTeedeli: 'Add Teedeli Promo Code',
    addMultiple: 'Add Multiple Promo Codes',
    disableCodes: 'Disable Codes',
    syncPiggyVouchers: 'Sync Piggy Vouchers',
    syncPiggyVouchersSuccess: 'Piggy vouchers have been synced successfully.',
    syncPiggyVouchersError: 'An error occurred while syncing Piggy vouchers. Please try again later.',
    disableHint: 'Please select a venue first',
    notification: {
      disableSuccess: 'Disabled promo codes successfully.',
    },
    types: {
      absolute: 'Absolute Value',
      relative: 'Relative Value',
      bogo: 'BOGO',
      deliveryFee: 'No Delivery Free',
      reward: 'Reward',
      giftCard: 'Gift Card',
      freeArticle: 'Free Article',
      void: 'Void',
      absoluteArticle: 'Article Discount (absolute) - DEPRECATED',
      relativeArticle: 'Article Discount (relative) - DEPRECATED',
      singleAbsoluteArticle: 'Article Discount (absolute)',
      singleRelativeArticle: 'Article Discount (relative)',
      multipleAbsoluteArticle: 'Multiple Article Discount (absolute)',
      multipleRelativeArticle: 'Multiple Article Discount (relative)',
      dependencyFreeArticle: 'Dependency Free Article',
      cheapestFreeArticle: 'Cheapest Article Free',
      cheapestHalfArticleDiscountRelative: 'Discount on the half of articles',
      mostExpensiveArticleDiscountRelative: 'Most Expansive Article Discount (relative)',
      teedeliPremium: 'Article Discount (premium)',
      unlockArticles: 'Unlock Articles',
      coupon: 'Coupon',
      multipleFreeArticles: 'Multiple Free Articles',
    },
    table: {
      name: 'Name',
      code: 'Code',
      customerGroup: 'Customer Group',
      mov: 'Minimum Order Value',
      from: 'Valid from',
      to: 'Valid to',
      disabled: 'Disabled (Venue only)',
      venues: 'Venues',
      type: 'Type',
      value: 'Value',
      active: 'Active (Global)',
      disabledBy: 'Disabled by',
      countries: 'Countries',
      states: 'States',
      amount: 'Max. Usage',
      unlimited: 'Unlimited',
    },
    form: {
      offerPeriod: 'Offer Period',
      unlimitedTime: 'Unlimited Time',
      unlimitedAmount: 'Unlimited Usage',
      lightspeedCode: 'Lightspeed Code',
      simphonyCode: 'Simphony Code',
      useCustomerRedemptionCodes: 'PromoCodes as one time codes',
      name: 'Name',
      code: 'Code',
      description: 'Description',
      venue: 'Venue',
      valid: 'Valid',
      article: 'Article',
      generateAmount: 'Amount to generate',
      label: 'Venue Label',
      isMultipleApplicable: 'Customer can use it more than once',
      applyOnAnyQuantity: 'Apply On Any Quantity',
      customerGroup: 'Customer Group',
      countries: 'Countries',
      states: 'States/Regions',
      codes: 'Promo Codes',
      uploadGiftCards: 'CSV file with Gift Cards',
      venues: 'Venues',
      type: 'Type',
      freeArticle: 'Free Article',
      bogoArticles: 'Possible Articles (cheapest product from cart will be used for bogo)',
      mov: 'Minimum Order Value',
      amount: 'Maximum usage',
      amountTeedeli: 'Amount of promo codes',
      amountUsesTeedeli: ' Max. Usage',
      active: 'Active',
      value: 'Value',
      discount: 'Discount',
      percent: 'Value (e.g. 20% please enter 0.2)',
      standardAvailability: 'Available',
      insideAvailability: 'Available inside',
      takeAwayAvailability: 'Available for take away',
      deliveryAvailability: 'Available for delivery',
      preorderParkCollect: 'Available for park & collect',
      preorderFoodspot: 'Available for foodspot',
      webAvailability: 'Available',
      isMaster: 'Is Master',
      generalPromoCode: 'General Promocode',
      registrationRequired: 'Registration Required',
      boundToUser: 'Bound To User',
      usageFrequency: 'Usage frequency',
      minQuantity: 'Minimum Quantity',
      maxQuantity: 'Max. amount of discountable articles',
      isAutomatic: 'Trigger automatically',
      isPiggyVoucher: 'Piggy Voucher',
      banner: 'Banner',
      discountableMainCategories: 'Discountable Main Categories',
    },
    usageFrequency: {
      any: 'Any',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
    },
    tabs: {
      general: 'General',
      availability: 'Availability',
      images: 'Images',
      availableHours: 'Available hours',
      banner: 'Banner',
    },
    standardAvailability: 'Standard Availability',
    terminalAvailability: 'Terminal Availability',
    preorderAvailability: 'Preorder Availability',
    webAvailability: 'Web Availability',
    weekdaysAvailability: 'Weekdays Availability',
    cateringAvailability: 'Catering Availability',
  },
  cupCode: {
    index: 'Manage Cup Code',
    create: 'Create a new Cup Code',
    edit: 'Edit Cup Code',
    overview: 'Overview',
    add: 'Add Cup Code',
    downloadCodes: 'Export Codes',
    downloadQRCode: 'Download QR codes',
    action: 'Actions on a range of codes',
    form: {
      number: 'Number',
      venue: 'Venue',
      active: 'Active',
      quantity: 'Number of codes to be generated',
      startingFrom: 'Starting number of codes',
      customerGroup: 'Select customer groups',
      format: 'Select format file',
    },
    table: {
      number: 'Number',
      venue: 'Venue',
      customerGroup: 'Customer Groups',
      quantity: 'Quantity',
      startingFrom: 'Starting From',
      active: 'Active',
      qrCode: 'QR Code',
      createdAt: 'Created',
    },
    filter: {
      customerGroup: 'Customer Groups',
      active: 'Active',
      numFrom: 'Number From',
      numTo: 'Number To',
    },
  },
  coupon: {
    index: 'Manage Coupon (deprecated)',
    create: 'Create a new Coupon',
    edit: 'Edit Coupon',
    exportCsv: 'Export',
    exportSummary: 'Export Summary',
    exportCount: 'Export Activation Summary',
    overviewCsv: 'Export Coupon',
    overview: 'Overview',
    add: 'Add Coupon',
    addMultiple: 'Add Multiple Coupon',
    disableCodes: 'Disable Coupon',
    disableHint: 'Please select a venue first',
    notification: {
      disableSuccess: 'Disabled coupon successfully.',
    },
    form: {
      offerPeriod: 'Offer Period',
      lightspeedCode: 'Lightspeed Code',
      name: 'Name',
      code: 'Code',
      venue: 'Venue',
      valid: 'Valid',
      article: 'Article',
      generateAmount: 'Amount to generate',
      label: 'Venue Label',
      isMultipleApplicable: 'Customer can use it more than once',
      applyOnAnyQuantity: 'Apply On An yQuantity',
      customerGroup: 'Customer Group',
      countries: 'Countries',
      states: 'States/Regions',
      codes: 'Coupon',
      uploadGiftCards: 'CSV file with Gift Cards',
      venues: 'Venues',
      type: 'Type',
      freeArticle: 'Free Article',
      bogoArticles: 'Possible Articles (cheapest product from cart will be used for bogo)',
      mov: 'Minimum Order Value',
      amount: 'Maximum usage',
      active: 'Active',
      value: 'Value',
      discount: 'Discount',
      percent: 'Value (e.g. 20% please enter 0.2)',
      standardAvailability: 'Available',
      insideAvailability: 'Available inside',
      takeAwayAvailability: 'Available for take away',
      deliveryAvailability: 'Available for delivery',
      preorderParkCollect: 'Available for park & collect',
      preorderFoodspot: 'Available for foodspot',
      webAvailability: 'Available',
      image: 'Image',
      banner: 'Banner',
      usageFrequency: 'Usage frequency',
      redeemableAtCheckoutOnly: 'Redeemable',
    },
    types: {
      absolute: 'Absolute Value',
      relative: 'Relative Value',
      bogo: 'BOGO',
      deliveryFee: 'No Delivery Free',
      reward: 'Reward',
      giftCard: 'Gift Card',
      freeArticle: 'Free Article',
      void: 'Void',
      absoluteArticle: 'Article Discount (absolute)',
      relativeArticle: 'Article Discount (relative)',
      plusOneFree: '1 + 1 Free',
    },
    usageFrequency: {
      any: 'Any',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
    },
    table: {
      name: 'Name',
      code: 'Code',
      customerGroup: 'Customer Group',
      mov: 'Minimum Order Value',
      from: 'Valid from',
      to: 'Valid to',
      disabled: 'Disabled (Venue only)',
      venues: 'Venues',
      type: 'Type',
      value: 'Value',
      active: 'Active (Global)',
      disabledBy: 'Disabled by',
      countries: 'Countries',
      states: 'States',
      amount: 'Max. Usage',
    },
    tabs: {
      general: 'General',
      availability: 'Availability',
      images: 'Images',
    },
    standardAvailability: 'Standard Availability',
    terminalAvailability: 'Terminal Availability',
    preorderAvailability: 'Preorder Availability',
    webAvailability: 'Web Availability',
    weekdaysAvailability: 'Weekdays Availability',
    cateringAvailability: 'Catering Availability',
  },
  receipt: {
    index: 'Receipts',
    overview: 'Overview',
    receipts: 'Receipts',
    endOfDayReceipts: 'End Of Day Receipts',
    form: {
      flavor: 'Order Flavor',
      venue: 'Venue',
    },
    table: {
      code: 'Order Code',
      at: 'At',
      sum: 'Sum',
      endOfDay: 'End of day',
      merchantReceipt: 'Merchant Receipt',
      customerReceipt: 'Customer Receipt',
      posCheckoutReceipt: 'Checkout Receipt',
      exportCustomer: 'Export customer receipt',
      exportMerchant: 'Export merchant receipt',
      exportCombined: 'Export merchant and customer receipt',
      exportFull: 'Export receipts',
      tableNumber: 'Table Number',
    },
  },
  eposJobs: {
    index: 'Jobs',
    overview: 'Overview',
    form: {
      venue: 'Venue',
      status: 'Status',
      requestId: 'Request Id',
      success: 'Success',
      failed: 'Failed',
      partiallyFailed: 'Partially Failed',
      pending: 'Pending',
      started: 'Started',
      sortByCreatedAt: 'Date last created',
      oldestToNewest: 'Oldest To Newest',
      newestToOldest: 'Newest To Oldest',
    },
    table: {
      sapNumber: 'Sap Number',
      status: 'Status',
      statusMessage: 'Status Message',
      createdAt: 'Created At',
      finalizedAt: 'Finalized At',
      exportFull: 'Export receipts',
      requestId: 'Request Id',
      ID: 'Changes ID',
      articleType: 'Article Type',
      itemId: 'Item ID',
      price: 'Price',
      taxInside: 'Tax Inside',
      taxTakeaway: 'Tax Takeaway',
      visibility: 'Visibility',
      oldValue: 'Old Value',
      newValue: 'New Value',
      priceRuleId: 'Price Rule Id',
      effectiveDateTimestamp: 'Effective Date Timestamp',
      expirationDateTimestamp: 'Expiration Date Timestamp',
      priceRuleSet: 'Price Rule Set',
      statusCode: 'Status Code',
      taxIdInside: 'Tax ID Inside',
      taxIdTakeaway: 'Tax ID Takeaway',
      errorList: 'Error list',
      errorId: 'Error ID',
      articleName: 'Article Name',
      negativeFlag: 'Negative Flag',
      exportRawRequest: 'Export Raw Request',
      exportChanges: 'Export Changes',
    },
  },
  sanifairLogs: {
    index: 'Sanifair',
    overview: 'Overview',
    form: {
      venue: 'Venue',
      status: 'Status',
      search: 'Search',
      actionTypes: 'Action Types',
    },
    table: {
      sanifairActionType: 'Action Types',
      order: 'Order',
      responseTimeSanifair: 'Response Time Sanifair',
      responseTimeSmoothr: 'Response Time Smoothr',
      responseTimeTotal: 'Response Time Total',
      createdAt: 'Created At',
      sanifairRequestReceivedAt: 'Sanifair Request Received At',
      sanifairResponseReceivedAt: 'Sanifair Response Received At',
      smoothrRequestReceivedAt: 'Smoothr Request Received At',
      smoothrResponseReceivedAt: 'Smoothr Response Received At',
    },
  },
  automatedReports: {
    index: 'Automated Reports',
    overview: 'Overview',
    add: 'Add Automated Report',
    form: {
      type: 'Type',
      venue: 'Venue',
      customerGroup: 'Customer Group',
      flavor: 'Flavor',
      lang: 'Lang',
      frequency: 'Frequency',
      venueLabels: 'Venue Labels',
      lastExecuted: 'Last Executed',
      receiver: 'Receiver',
      cc: 'CC',
      active: 'Active',
    },
    tabs: {
      general: 'General',
    },
    table: {
      type: 'Type',
      customerGroup: 'Customer Group',
      flavor: 'Flavor',
      frequency: 'Frequency',
      venueLabels: 'Venue Labels',
      lastExecuted: 'Last Executed',
      receiver: 'Receiver',
      selectVenue: 'Please select venue',
      selectGroup: 'Please select customer group',
    },
    types: {
      orders: 'Orders',
      orderByPaymentMethod: 'Order By Payment Method',
      sales: 'Sales',
      pdfBillingShort: 'PDF Billing Short',
      pdfBillingLong: 'PDF Billing Long',
    },
    frequency: {
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      yearly: 'Yearly',
    },
  },
  paypal: {
    index: 'PayPal',
    success: 'PayPal authorization was successfully',
    description:
      'PayPal authorization was successfully. After our employees have checked your account status, paypal payments will be activated.',
  },
  validations: {
    eod_email_enable: 'The list should contain valid emails before enabling this',
    list_of_emails: 'Your email should be separated by a coma.',
    list_of_integer: 'Excluded tenders should be separated by a coma.',
    numbers_with_comma_or_dot: 'The {field} field must be a number.',
    quantity_number: 'The number cannot be greater.',
    quantity_number_less_100k: 'The difference cannot be more than 100 000 and less than 0',
    quantity_number_less_10k: 'The difference cannot be more than 10 000 thousand and less than 0',
    unique_email: 'The email is already in use',
    admin_smoothr_email: 'Admin users must use an @smoothr.de email address.',
    readable_id: 'The short id is already taken.',
    venue_label: 'The venue label already exists.',
    password:
      'Password must contain one capital letter, one number or special character and be at least 8 characters long.',
    identifier: 'The identifier must contain only lowercase letters separated with a single underscore',
    date_before: 'The {field} field must be before {target}',
    time_before: 'The {field} field must be before {target}',
    unique_dependency: 'The {field} is a duplicate',
    smaller_eq_than: 'The {field} must be at most {target}.',
    smaller_than: 'The {field} must be smaller than {target}.',
    greater_than: 'The {field} must be greater than {target}.',
    greater_eq_than: 'The {field} must be at least {target}.',
    uppercase: 'Only upper-case letters allowed',
    price: 'The {field} must be a valid price (e.g. 1.99)',
    nutritional_value: 'The {field} must be a valid nutritional value (e.g. 1.99)',
    uniqueFile: 'The uploaded media can not be changed. Please create a new step.',
    time: 'The time format is HH:mm.',
    url: 'Please enter a valid domain without http/https, just the domain and the TLD.',
    url_simple: 'Please enter a valid full URL with http/https',
    url_ios_android: 'The {field} must be a valid URL for the {storeType} Store',
    loyalty_campaign: "The {field} must be a valid campaign that starts with 'camp_'",
    phone: 'Please enter a valid phone number (e.g. +4912345678901)',
    uniq_company_code: 'This company code is already taken. Please choose a different code.',
    iban: 'Invalid IBAN format. Please enter a correct IBAN.',
    vatNumber: {
      info: 'Valid VAT Number with minimum length of 5 required',
      error:
        'VAT Number is invalid or already taken by other user. Please enter another VAT number or contact an administrator to solve the issue.',
    },
    vatNumberGermany: {
      info: 'Valid German Tax Number with minimum length of 5 required',
      error:
        'German Tax Number is invalid or already taken by other user. Please enter another VAT number or contact an administrator to solve the issue.',
    },
  },
  footer: {
    imprint: 'Imprint',
    terms: 'Data Policies',
  },
  reporting: {
    index: 'Reporting',
    form: {
      type: 'Type',
      periodType: 'Period',
      label: 'Venue Label',
      country: 'Country',
      venue: 'Venue',
      flavor: 'Flavor',
      customerGroup: 'Customer Group',
    },
    periods: {
      daily: 'Day',
      weekly: 'Week',
      monthly: 'Month',
      total: 'Total',
    },
    types: {
      stores: 'Venue',
      products: 'Article',
      customers: 'Customer',
    },
  },
  screensaver: {
    index: 'Screensaver',
    add: 'Create Screensaver',
    mediaType: 'Media type',
    duration: 'Duration',
    level: 'Level',
    preview: 'preview',
    title: 'Screensaver Step',
    hours: 'Hours',
    overview: 'Overview',
    stepSavingInfo: 'Media will upload in a moment, please wait.',
    category: 'Category',
    form: {
      name: 'Name',
      customerGroup: 'Customer Group',
      linkedCustomerGroup: 'Linked Customer Group',
      venues: 'Venues',
      openingHours: 'Opening Hours',
      file: 'Asset',
      duration: 'Duration in seconds',
      level: 'Level',
      saveOrder: 'Save new order',
      changeOrder: 'Change order',
      slug: 'Slug',
      visible: 'Visible',
      category: 'Category',
      articles: 'Articles',
    },
    tabs: {
      screensaver: 'Screensaver',
      upsellArticles: 'Upsell Articles',
      steps: 'Steps',
      info: 'You can add steps only after creating screensaver',
    },
    table: {
      steps: 'Steps Count',
    },
  },
  employeeNotification: {
    index: 'Employee Notification',
    add: 'Create Employee Notification',
    form: {
      title: 'Title',
      message: 'Message',
    },
  },
  loyaltyPrograms: {
    index: 'Loyalty Programs',
    add: 'Create Loyalty Program',
    create: 'Create Loyalty Program',
    edit: 'Edit Loyalty Programs',
    overview: 'Overview',
    general: 'General',
    clientCredentials: 'Client Credentials',
    rbiCredentials: 'Rbi Credentials',
    form: {
      type: 'Type',
      customerGroup: 'Customer Group',
      apikey: 'Api Key',
      oauthId: 'Oauth ID',
      oauthSecret: 'Oauth Secret',
      operator: 'Operator',
      posType: 'Pos Type',
      storeId: 'Store Id',
      supportingPos: 'Supporting Pos',
      piggy: 'Piggy',
      como: 'Como',
      internal: 'Internal',
      rbi: 'Rbi',
      shopUuid: 'Shop Uuid',
    },
    table: {
      type: 'Type',
      customerGroup: 'Customer Group',
      apikey: 'Api Key',
      oauthId: 'Oauth ID',
      oauthSecret: 'Oauth Secret',
      shopUuid: 'Shop Uuid',
      venue: 'Venue',
      operator: 'Operator',
      posType: 'Pos Type',
      storeId: 'Store Id',
      supportingPos: 'Supporting Pos',
    },
  },
  banner: {
    index: 'Manage Banners',
    add: 'Create banner',
    table: {
      name: 'Name',
      type: 'Type',
      linkedCategory: 'Linked Category',
      linkedArticle: 'Linked Article',
    },
    form: {
      name: 'Name',
      type: 'Type',
      linkedCategory: 'Linked Category',
      linkedArticle: 'Linked Article',
      imageDe: 'Image (de)',
      imageEn: 'Image (en)',
      imageFr: 'Image (fr)',
    },
  },
  lightspeed: {
    syncFoodcard: 'Sync',
    success: 'Lightspeed has been successfully authorized',
    successDescription:
      'Congratulations! Lightspeed has been successfully authorized. Please contact your key account manager to complete the integration. You can close this page now.',
    error: 'Lightspeed could not be authorized',
    errorDescription:
      'Unfortunately, an unknown error occurred while authorizing Lightspeed. Please contact support or your key account manager. You can close this page now.',
    notification: {
      foodcardSyncSuccess: 'Menu is being synchronized. This takes about 15 minutes.',
      foodcardSyncError: 'Menu could not be synchronized. Please inform an administrator.',
      tablesSyncSuccess: 'Tables are being synchronized. This takes about 5 minutes.',
      tablesSyncError: 'Tables could not be synchronized. Please inform an administrator.',
    },
    modes: {
      create_and_update: 'Sync all',
      create_only: 'Sync new items',
      update_only: 'Sync changes',
      price_and_active: 'Sync prices/visibilities',
      price_only: 'Sync prices only',
      images_only: 'Sync images only',
      tables: 'Sync tables',
    },
  },
  copy_venue: {
    not_selected_to: 'You must select a destination to copy to',
    success: 'Venue was copied successfully',
    error: 'something went wrong',
    btn_title: 'Copy Settings',
    from: 'From',
    to: 'To',
  },
  sync: {
    index: 'Sync',
    sync: 'Sync',
    syncUpsells: 'Sync Upsells',
    config: 'Config',
    created: 'Created',
    updated: 'Updated',
    deleted: 'Deleted',
    collapseAll: 'Collapse All',
    expandAll: 'Expand All',
    warnings: 'Warnings',
    directions: {
      d2d: 'Dev-to-Dev',
      d2p: 'Dev-to-Prod',
      p2d: 'Prod-to-Dev',
      p2p: 'Prod-to-Prod',
    },
    notification: {
      running: 'The sync has been started',
      error: 'There was an error. Please check the logs.',
    },
    modes: {
      'master-to-slaves': 'Master -> Slaves',
      'slave-to-slaves': 'Slave -> Slaves',
    },
    deleteModes: {
      ignore: 'No change/No deletion',
      soft: 'Soft-Delete',
      hard: 'Hard-Delete',
    },
    table: {
      id: 'Id',
      name: 'Name',
      user: 'User',
      status: 'Status',
      createdAt: 'Created',
      today: 'Today',
      finishedAt: 'Finished',
      config: 'Config',
      changes: 'Changes',
      stopSync: 'Stop Sync',
      refresh: 'Refresh',
    },
    form: {
      main: 'Main-Venue (Slave/Master)',
      slaves: 'Slave-Venues',
      direction: 'From/To',
      mode: 'Mode',
      deleteMode: 'Delete mode',
      articleCategoryProps: 'Category-Props',
      categories: 'Categories',
      articleProps: 'Article-Props',
      venueProps: 'Venue-Props',
      optionGroupProps: 'Optiongroup-Props',
      optionArticleProps: 'Optionarticle-Props',
      selectAll: 'Select All',
      upsells: 'Upsells',
      useSyncTags: 'Sync based on Sync-Tags',
    },
    props: {
      articleCategory: {
        sortOrder: 'Sort order',
        visible: 'Visibility',
        displayMode: 'Display Mode',
        displayIdentifiers: 'Display Identifiers',
        mainCategory: 'Main category',
        availableHours: 'Available hours',
        name: 'Name',
        description: 'Description',
        assets: 'Main image',
        icon: 'Icon',
        tags: 'Tags',
        constrains: 'Constrains',
        features: 'Features',
        mainRecommendations: 'Main recommendations',
        printerSortOrder: 'Printer Sort Order',
      },
      article: {
        price: 'Price',
        basePrice: 'Base price',
        referencePrice: 'Reference price',
        taxTakeaway: 'Tax (Takeaway)',
        taxInside: 'Tax (Insde)',
        sortOrder: 'Sort order',
        visible: 'Visibility',
        isActive: 'Active status',
        deposit: 'Deposit',
        isControlArticle: 'Control article flag',
        internalNote: 'Internal note',
        internalName: 'Internal Name',
        externalId: 'External ID',
        number: 'Number',
        priceIsLocked: 'Price-Lock',
        isNoticeable: 'Noticeable',
        description: 'Description',
        name: 'Name',
        info: 'Info',
        shortDescription: 'Short description',
        assets: 'Main image',
        icon: 'Icon',
        banner: 'Banner',
        measurement: 'Measurement',
        groupDependencies: 'Group Dependencies',
        groups: 'Optionsgruppen',
        defaults: 'Defaults',
        recommendations: 'Recommendations',
        priceByType: 'Price by order type',
        displayPriceByType: 'Visible Price by order type',
        availability: 'Availability',
        tags: 'Tags',
        constrains: 'Constrains',
        counterArticle: 'Counter article',
        mainRecommendations: 'Main recommendations',
        articleRelativeBrand: 'Brand',
        styles: 'Styles',
        additives: 'Additives',
        allergens: 'Allergens',
        features: 'Features',
        traces: 'Traces',
        externalOrderProviderSettings: 'External Order Provider Settings',
        loyaltyId: 'Loyalty Id',
        requiredLoyaltyPoints: 'Required Loyalty Points',
        plu: 'PLU',
        gtin: 'GTIN',
        nutritions: 'Nutrition',
        displayMode: 'Display Mode',
        displayModeSot: 'Display Mode (Sot)',
        displayModeMobile: 'Display Mode (Mobile)',
        manufacturer: 'Manufacturer',
        caffeineMg: 'Caffeine (mg)',
        alcoholPercentage: 'Alcohol Percentage',
        availableHours: 'Available Hours',
        printerSortOrder: 'Printer Sort Order',
        dimension: 'Dimensions',
        weight: 'Weight',
        foodInstructions: 'Food Instructions',
        storageInstructions: 'Storage Instructions',
      },
      venue: {
        movDelivery: 'MOV',
        preorderTakeAway: 'Preorder (Takeaway)',
        preorderIn: 'Preorder (Inside)',
        deliveryEnabled: 'Preorder (Delivery)',
        sendProvisionReportPeriod: 'Provision report',
        isServiceActivated: 'Service-Status',
        offsets: 'Offsets',
        invoiceReceiver: 'Invoice receiver',
        slot: 'Slotting',
        legal: 'Legal',
        openingHours: 'Opening hours',
        deliveryHours: 'Delivery hours',
        nutritionTable: 'Nutrition table',
        nutritionInfo: 'Nutrition info',
      },
      optionGroup: {
        hasMultiple: 'Multiple selection',
        limit: 'Limit',
        sortOrder: 'Sort order',
        requiredAmount: 'Required amount',
        name: 'Name',
        description: 'Description',
        shortDescription: 'Short description',
        backgroundImage: 'Background image',
        tags: 'Tags',
        displayMode: 'Display Mode',
        displayModeSot: 'Display Mode (Sot)',
        displayModeMobile: 'Display Mode (Mobile)',
        printerSortOrder: 'Printer Sort Order',
      },
      optionArticle: {
        price: 'Price',
        basePrice: 'Base price',
        referencePrice: 'Reference price',
        taxTakeaway: 'Tax (Takeaway)',
        taxInside: 'Tax (Insde)',
        sortOrder: 'Sort order',
        visible: 'Visibility',
        isActive: 'Active status',
        deposit: 'Deposit',
        isControlArticle: 'Control article flag',
        internalNote: 'Internal note',
        internalName: 'Internal Name',
        foodInstructions: 'Food Instructions',
        storageInstructions: 'Storage Instructions',
        externalId: 'External ID',
        optionNumber: 'Number',
        number: 'Number',
        priceIsLocked: 'Price-Lock',
        isNoticeable: 'Noticeable',
        description: 'Description',
        name: 'Name',
        info: 'Info',
        shortDescription: 'Short description',
        assets: 'Main image',
        icon: 'Icon',
        banner: 'Banner',
        measurement: 'Measurement',
        groupDependencies: 'Group Dependencies',
        groups: 'Optionsgruppen',
        defaults: 'Defaults',
        recommendations: 'Recommendations',
        priceByType: 'Price by order type',
        displayPriceByType: 'Visible Price by order type',
        availability: 'Availability',
        tags: 'Tags',
        constrains: 'Constrains',
        counterArticle: 'Counter article',
        mainRecommendations: 'Main recommendations',
        requirements: 'Article requirements',
        articleRelativeBrand: 'Brand',
        styles: 'Styles',
        additives: 'Additives',
        allergens: 'Allergens',
        features: 'Features',
        traces: 'Traces',
        externalOrderProviderSettings: 'External Order Provider Settings',
        loyaltyId: 'Loyalty Id',
        requiredLoyaltyPoints: 'Required Loyalty Points',
        plu: 'PLU',
        gtin: 'GTIN',
        nutritions: 'Nutrition',
        manufacturer: 'Manufacturer',
        caffeineMg: 'Caffeine (mg)',
        alcoholPercentage: 'Alcohol Percentage',
        printerSortOrder: 'Printer Sort Order',
        dimensions: 'Dimensions',
        weight: 'Weight',
      },
      upsell: {
        addon: 'Basket Upsell',
        goal: 'Rounding Upsell',
        upgrade: 'Article Upsell',
      },
    },
  },
  injectionRates: {
    title: 'Injection Rates',
    subtitle: 'External provider injection success rate',
    error: 'Could not load injection rates.',
    filters: {
      venue: 'Venue',
      customerGroup: 'Customer group',
      provider: 'Provider',
    },
    table: {
      provider: 'Provider',
      venue: 'Venue',
      received: 'Received',
      injected: 'Injected',
      failed: 'Failed',
      rate: 'Injection rate',
      total: 'Total',
    },
    providers: {
      wolt: 'Wolt',
      uber_eats: 'Uber Eats',
      jet: 'Lieferando',
      deliveroo: 'Deliveroo',
    },
  },
  aggregatorSyncs: {
    index: 'Aggregator Syncs',
    wolt: 'Wolt',
    uberEats: 'Uber-Eats',
    jet: 'Jet',
    deliveroo: 'Deliveroo',
    noWolt: 'No Wolt data available.',
    noJet: 'No Jet data available.',
    noUberEats: 'No Uber-Eats data available.',
    noDeliveroo: 'No Deliveroo data available.',
    table: {
      name: 'Name',
      user: 'User',
      status: 'Status',
      createdAt: 'Created',
      finishedAt: 'Finished',
    },
    filter: {
      status: 'Select Status',
    },
    status: {
      created: 'Created',
      in_progress: 'In Progress',
      done: 'Done',
      failed: 'Failed',
    },
  },
  posSync: {
    index: 'POS Sync',
    table: {
      venue: 'Venue',
      status: 'Status',
      user: 'User',
      syncMode: 'Sync Mode',
      errorMessage: 'Error Message',
      createdAt: 'Created At',
      startedAt: 'Started At',
      finishedAt: 'Finished At',
      failedAt: 'Failed At',
    },
  },
  orderProviders: {
    wolt: {
      success: {
        title: 'Venue has been successfully connected to Wolt',
        description:
          'Your venue has been successfully connected to Wolt. You can now synchronize your foodcard and receive orders.',
      },
      error: {
        title: 'Venue could not be connected to Wolt',
        description: 'An error has occurred. Please contact our support:',
      },
    },
    uberEats: {
      success: {
        title: 'Venue has been successfully connected to Uber Eats',
        description:
          'Your venue has been successfully connected to Uber Eats. You can now synchronize your foodcard and receive orders.',
      },
      error: {
        title: 'Venue could not be connected to Uber Eats',
        description: 'An error has occurred. Please contact our support:',
      },
    },
  },
  simphony: {
    syncFoodcard: 'Sync prices/visibilities',
    syncPrices: 'Sync prices only',
    syncActive: 'Sync visibilities only',
    refreshCnc: 'Refresh CNC',
    fullSync: 'Full Sync',
    addOnly: 'Add only',
    notification: {
      foodcardSyncSuccess: 'Prices/visibilities have been successfully synchronized.',
      foodcardSyncError: 'Could not synchronize prices/visibilities. Please check the logs.',
      pricesSyncSuccess: 'Prices have been successfully synchronized.',
      pricesSyncError: 'Could not synchronize prices. Please check the logs.',
      activeSyncSuccess: 'Visibilities have been successfully synchronized.',
      activeSyncError: 'Could not synchronize visibilities. Please check the logs.',
      refreshCncSuccess: 'CNC has been successfully refreshed.',
      refreshCncError: 'Could not refresh CNC. Please check the logs.',
      addOnlySuccess: 'New items have been successfully synchronized.',
      addOnlyError: 'Could not synchronize new items. Please check the logs.',
    },
  },
  kost: {
    syncFoodcard: 'Sync foodcard',
    notification: {
      foodcardSyncSuccess: 'Foodcard has been successfully synchronized.',
      foodcardSyncError: 'Could not synchronize foodcard. Please check the logs.',
    },
  },
  ncr: {
    syncFoodcard: 'Sync foodcard',
    notification: {
      foodcardSyncSuccess: 'Foodcard has been successfully synchronized.',
      foodcardSyncError: 'Could not synchronize foodcard. Please check the logs.',
    },
  },
  fullcircle: {
    sync: 'Sync',
    syncMenu: 'Sync menu',
    notification: {
      menuSyncQueued: 'Sync has been queued. Follow it under sync jobs.',
      menuSyncError: 'Could not queue the sync. Please check the logs.',
    },
    modes: {
      full: 'Full sync',
      price_only: 'Only sync prices',
    },
  },
  revel: {
    sync: 'Sync',
    syncMenu: 'Sync menu',
    notification: {
      menuSyncSuccess: 'Menu has been successfully synchronized.',
      menuSyncError: 'Could not synchronize menu. Please check the logs.',
    },
    modes: {
      full: 'Full sync',
      add_only: 'Only add',
      price_only: 'Only sync prices',
      active_only: 'Only sync visibilities',
    },
  },
  lina: {
    syncPrices: 'Sync prices',
    notification: {
      pricesSyncSuccess: 'Prices have been successfully synchronized.',
      pricesSyncError: 'Could not synchronize prices. Please check the logs.',
    },
  },
  ui: {
    banner: {
      index: 'Banners',
      overview: 'Overview',
      general: 'Details',
      add: 'Create Banner',
      create: 'Create a new Banner',
      edit: 'Edit Banner',
      empty: "It looks like you haven't added any banners yet. Create your first banner now!",
    },
    card: {
      index: 'Cards',
      overview: 'Overview',
      general: 'Details',
      add: 'Create Card',
      create: 'Create a new Card',
      edit: 'Edit Card',
      empty: "It looks like you haven't added any cards yet. Create your first card now!",
    },
    slider: {
      index: 'Sliders',
      overview: 'Overview',
      general: 'Details',
      add: 'Create Slider',
      create: 'Create a new Slider',
      edit: 'Edit Slider',
      empty: "It looks like you haven't added any sliders yet. Create your first slider now!",
    },
    form: {
      customerGroup: 'Customer Group',
      title: 'Title',
      identifier: 'Identifier',
      textColor: 'Text Color',
      backgroundColor: 'Background Color',
      backgroundImage: 'Background Image',
      htmlContent: 'HTML Content',
      primaryClickAction: 'Primary Click Action',
      type: 'Type',
      value: 'Value',
      label: 'Label',
      addAction: 'Add Action',
      removeAction: 'Remove Action',
      slides: 'Slides',
      actionType: 'Action Type',
      description: 'Description',
      action: 'Actions',
    },
  },
  releases: {
    index: 'Releases',
    overview: 'Overview',
    general: 'Details',
    add: 'Create Release',
    create: 'Create a new Release',
    edit: 'Edit Release',
    empty: "It looks like you haven't added any releases yet. Create your first release now!",
    form: {
      customerGroup: 'Customer Group',
      platform: 'Platform',
      version: 'Version',
      forceUpdate: 'Force Update',
      description: 'Description',
      link: 'Link',
      isLatest: 'Current Version',
      isLatestHint: 'If the field is active, the current version will be overwritten.',
      platforms: {
        IOS: 'iOS',
        ANDROID: 'Android',
      },
    },
  },
  auditing: {
    index: 'Auditing',
    overview: 'Overview',
    table: {
      action: 'Action',
      message: 'Subject',
      target: 'Resource',
      actor: 'User',
      changes: 'Changes',
      createdAt: 'Date',
      venue: 'Venue',
      customerGroup: 'Customer Group',
    },
  },
  enrollments: {
    index: 'Enrollments',
    overview: 'Übersicht',
    accept: 'Accept',
    reject: 'Reject',
    comment: 'Comment',
    table: {
      deviceType: 'Device type',
      serialNumber: 'Serial number',
      venue: 'Venue',
      appInformation: 'App',
      role: 'Role',
      enrollmentStatus: 'Status',
      rolloutStatus: 'Rollout Status',
      isActive: 'Active',
      venues: 'Venues',
      reviewerId: 'Reviewer ID',
    },
  },
  campaign: {
    index: 'Campaign',
    overview: 'Overview',
    general: 'Details',
    add: 'Create Campaign',
    create: 'Create a new Campaign',
    edit: 'Edit Campaign',
    empty: "It looks like you haven't added any campaigns yet. Create your first campaign now!",
    form: {
      customerGroup: 'Customer Group',
      name: 'Name',
      content: 'Content',
      subject: 'Subject',
      clickAction: 'Click Action',
      url: 'URL',
      venues: 'Venues',
      status: 'Status',
      error: 'Error',
      scheduledAt: 'Scheduled',
    },
    table: {
      customerGroup: 'Select Customer Group',
    },
  },
  seasonPass: {
    index: 'Season Pass',
    warning: 'A successful import overwrites all existing entries.',
    upload: 'Upload CSV',
    csv: 'Season Pass CSV file',
    successfulUpload: 'Your Season Pass CSV file has been successfully uploaded',
  },
  upsell: {
    index: 'Upsells',
    overview: 'Overview',
    types: {
      addon: 'Basket Upsell',
      goal: 'Rounding Upsell',
      upgrade: 'Article Upsell',
    },
    table: {
      position: 'Position',
      article: 'Article',
      upgradeFrom: 'PLU Small',
      upgradeTo: 'PLU Large',
      mov: 'Minimum order value',
      roundTo: 'Rounded to',
      articles: 'PLU to add',
      plu: 'PLU',
    },
    form: {
      position: 'Position',
      article: 'Article',
      upgradeFrom: 'PLU Small',
      upgradeTo: 'PLU Large',
      mov: 'Minimum order value',
      roundTo: 'Rounded to',
      articles: 'PLU to add',
      isMaster: 'Is Master',
      isMasterNotice:
        'Please don\'t forget to set the "Is Master" flag (if needed) before adding the first item. Otherewise you won\'t be able to change it later',
    },
  },
  healthCheck: {
    index: 'Healthcheck',
    overview: 'Overview',
    general: 'Details',
    add: 'Create Healthcheck',
    create: 'Create a new Healthcheck',
    edit: 'Edit Healthcheck',
    empty: "It looks like you haven't added any Healthchecks yet. Create your first healthcheck now!",
    table: {
      venues: 'Venues',
      customerGroup: 'Customer Group',
      lastRunAt: 'Last Run At',
      status: 'Status',
      errorList: 'Errors',
      article: 'Article',
      category: 'Category',
      type: 'Type',
    },
    form: {
      venues: 'Venues',
      customerGroup: 'Customer Group',
    },
  },
  smoothrPay: {
    open: 'Open',
    adyen: {
      merchant: 'Merchant',
      noMerchants: 'No merchant configured yet.',
      needsAccountHolder: 'Create the account holder first — transactions and payouts are scoped to it.',
      setupFailed: 'Could not load the Adyen components.',
      retry: 'Try again',
    },
    payments: {
      title: 'Payments',
      subtitle: 'Transactions per Smoothr Pay merchant, served by Adyen.',
      selectMerchant: 'Select a merchant to see its transactions.',
    },
    payouts: {
      title: 'Payouts',
      subtitle: 'Payouts per Smoothr Pay merchant, served by Adyen.',
      selectMerchant: 'Select a merchant to see its payouts.',
    },
    index: 'Smoothr Pay',
    subtitle: 'Merchants, Adyen provisioning and venue stores',
    columns: {
      merchant: 'Merchant',
      owner: 'Owner',
      status: 'Status',
      verification: 'Verification',
      createdAt: 'Created',
    },
    status: {
      draft: 'Draft',
      invited: 'Invited',
      onboarding: 'Onboarding',
      active: 'Active',
      suspended: 'Suspended',
      closed: 'Closed',
    },
    channels: { ecom: 'Online', pos: 'Point of sale' },
    verification: { payIn: 'Pay-in', payOut: 'Payout', problems: 'problems' },
    create: {
      button: 'Add merchant',
      title: 'New merchant',
      businessLine: 'Business line',
      webAddressRequired: 'A business line selling online needs a web address.',
      webAddressInvalid: 'The web address must start with http:// or https://.',
      ownerRequired: 'Pick the user this configuration belongs to.',
    },
    fields: {
      merchantAccount: 'Adyen merchant account',
      defaultAccount: 'default',
      legalName: 'Legal name',
      description: 'Description',
      country: 'Country',
      channels: 'Sales channels',
      balanceAccount: 'Balance account',
      owner: 'Owner',
      industryCode: 'Industry code',
      salesChannels: 'Sales channels',
      webAddress: 'Web address',
      shopperStatement: 'Shopper statement',
      phoneNumber: 'Phone number',
      line1: 'Street and number',
      line2: 'Address line 2',
      postalCode: 'Postal code',
      city: 'City',
      stateOrProvince: 'State or province',
      splitConfiguration: 'Split configuration',
    },
    hints: {
      ownerSelf: 'The configuration is created for you — only admins can onboard on someone else’s behalf.',
      ownerAdmin: 'Search by name or email.',
      industryCode: 'Six-digit NAICS code Adyen expects, e.g. 722511',
      webAddress: 'Required when the line sells online',
      shopperStatement: 'Shown on the bank statement, max. 22 characters',
    },
    reports: {
      title: 'Reports',
      subtitle: 'Settlement overviews per Smoothr Pay merchant, one per month.',
      selectMerchant: 'Select a merchant to see its reports.',
      none: 'No reports generated for this merchant yet.',
      loadError: 'Could not load the reports.',
      generating: 'The document is being generated — try again in a moment.',
      downloadError: 'Could not fetch the download link.',
      columns: {
        period: 'Period',
        gross: 'Turnover',
        fees: 'Fees',
        net: 'Net',
        payouts: 'Paid out',
        generatedAt: 'Generated',
        download: 'Download',
      },
      status: {
        pending: 'Pending',
        generated: 'Generated',
        sent: 'Sent',
        failed: 'Failed',
      },
    },
    kycIssues: {
      title: '{count} open verification issue | {count} open verification issues',
      unknown: 'Issue reported without a message',
    },
    kyc: {
      title: 'Open the onboarding link',
      hint: 'Your browser blocked the new tab. The link is valid for a few minutes only.',
      open: 'Open onboarding',
      close: 'Close',
    },
    provisioning: {
      title: 'Adyen provisioning',
      hint: 'Runs in order. Each step is repeatable until Adyen accepts it.',
      run: 'Run',
      again: 'Run again',
      steps: {
        legalEntity: 'Legal entity',
        businessLines: 'Business lines',
        accountHolder: 'Account holder',
        balanceAccounts: 'Balance accounts',
        kyc: 'KYC onboarding',
      },
      descriptions: {
        legalEntity: 'Creates the legal entity at Adyen',
        businessLines: 'Creates one business line per configured line',
        accountHolder: 'Creates the account holder',
        balanceAccounts: 'Creates the balance accounts',
        kyc: 'Opens the hosted onboarding link for the merchant',
      },
    },
    businessLines: {
      title: 'Business lines',
      adyenId: 'At Adyen',
      notCreated: 'not created yet',
      editTitle: 'Edit business line',
      webAddressRequired: 'A line selling online must keep a web address.',
    },
    stores: {
      title: 'Venues and stores',
      venue: 'Venue',
      adyenStore: 'Adyen store',
      split: 'Split configuration',
      paymentMethods: 'Payment methods',
      close: 'Close store',
      editSplit: 'Split profile',
      splitDialog: {
        title: 'Change the split profile',
        message: 'Replaces the profile {venue} books through.',
        required: 'Pick a split profile.',
        noChanges: 'That is already this store’s profile.',
      },
      closeConfirm: 'Close this store? Adyen stops accepting payments for the venue.',
      none: 'No venue assigned yet.',
      assign: 'Assign a venue',
      assignButton: 'Create store',
      needsBusinessLine: 'A store needs a business line at Adyen — run the business-lines step first.',
      status: { pending: 'Pending', active: 'Active', inactive: 'Inactive', closed: 'Closed' },
    },
    paymentMethods: {
      title: 'Payment methods',
      method: 'Method',
      state: 'State',
      none: 'No payment method requested yet.',
      add: 'Request payment methods',
      request: 'Request',
      status: { pending: 'Pending', active: 'Active', disabled: 'Disabled' },
      applePayDomains: 'Apple Pay domains',
      applePayDomainsHint: 'Comma-separated, at least one',
      applePayDomainsRequired: 'Apple Pay needs at least one domain.',
      googlePayMerchantId: 'Google Pay merchant ID',
      googlePayMerchantIdHint: '16 to 20 characters',
      googlePayMerchantIdRequired: 'The Google Pay merchant ID must be 16 to 20 characters.',
      amexServiceLevel: 'Amex service level',
      amex: {
        noContract: 'No contract',
        gateway: 'Gateway contract',
        paymentDesignator: 'Payment designator contract',
      },
    },
    detail: {
      title: 'Merchant',
      owner: 'Owner',
      payIn: 'Pay-in allowed',
      payOut: 'Payout allowed',
      payout: 'Payout account',
      invite: 'Send invitation',
      resetToDraft: 'Reset to draft',
      resetConfirm: 'Reset this configuration to draft?',
      notFound: 'This merchant configuration does not exist.',
      back: 'Back to the list',
    },
    notification: {
      loadError: 'Could not load the merchant configurations.',
      created: 'Merchant configuration created.',
      createError: 'Could not create the merchant configuration.',
      stepDone: 'Provisioning step completed.',
      stepFailed: 'The provisioning step failed.',
      kycStarted: 'Onboarding link opened.',
      businessLineUpdated: 'Business line updated.',
      businessLineError: 'Could not update the business line.',
      storeCreated: 'Store created.',
      storeClosed: 'Store closed.',
      splitAttached: 'Split profile attached.',
      splitError: 'Could not attach the split profile.',
      storeError: 'The store request failed.',
      methodsRequested: 'Payment methods requested.',
      methodRemoved: 'Payment method removed.',
      methodsError: 'The payment-method request failed.',
      invited: 'Invitation sent.',
      inviteError: 'Could not send the invitation.',
      resetToDraft: 'Configuration reset to draft.',
      resetError: 'Could not reset the configuration.',
    },
  },
};
